import { Table } from 'antd';
import { pain013, pain014, pasc002, pasc004, pasc008, testcase1, testcase2 } from "../assets/base64/testcases";
import moment from 'moment';
import { DashboardIcon, ExpandIcon, LogIcon, MessagesIcon, SettingsIcon, SettlementIcon, TestcasesIcon, TestExecutionIcon, UsersIcon } from './menuIcons';
import { convertAndFormatToUtcDate, convertToLocalTime } from '../shared/utils';
import { APP_ROUTE_KEYS } from '../shared/constants/constants';
import { UploadFile } from '@mui/icons-material';

export const SUCCESS_MSG = 'accc';

export const menus = {
    DASHBOARD: 'Dashboard',
    MESSAGES: 'MESSAGES',
    SCENARIO: 'Test Cases Library',
    BATCHES: 'Batches',
    EXECUTIONS: 'Executions',
    SETTINGS: 'Settings',
    REPORTS:'Reports/System Messages',
    USERS: 'Users',
    CUSTOMERS: 'Customers',
    SETTLEMENT_ACCOUNT: 'SETTLEMENT_ACCOUNT',
    USER_AUDIT_LOG: 'User Activity Logs',
    UPLOAD_TESTCASE: 'Upload Test Cases',
    TEST_CASES_REPO: "Master Test Cases",
    PRE_REQUISITE_DATA: "Pre-requisite data",
    SYSTEM_MESSAGES:"System Messages",
    NOTIFICATIONS:"Notifications",
    CLEARDATA:"Clear Data",
    UPLOAD: 'Upload Test Cases'
    
}

export const onboardingScreen = {
    CHOOSE_SUBSCRIPTION: 'chooseSubscriptionPlan',
    SELECT_PARTICIPATION_TYPE: 'selectParticipationType',
    CONFIGURE_PARTICIPATION_TYPE: 'configureParticipationType',
}
export const menuItems = [
    {
        title: 'Dashboard',
        url: `${APP_ROUTE_KEYS.DASHBOARD.MASTER}`,
        key: 'Dashboard',
        icon: (isActive) => <DashboardIcon isActive={isActive} />,
        disabled: false,
        privilege: menus.DASHBOARD
    },
    {
        title: 'Messages',
        url: `${APP_ROUTE_KEYS.MESSAGE.MASTER}/${APP_ROUTE_KEYS.MESSAGE.XML_LIST}`,
        key: 'messages',
        icon: (isActive) => <MessagesIcon isActive={isActive} />,
        disabled: true,
        privilege: menus.MESSAGES
    },
    {
        title: 'Test Cases Library',
        icon: 'test-cases',
        key: 'testCases',
        disabled: false,
        icon: (isActive) => <TestcasesIcon isActive={isActive} />,
        privilege: menus.SCENARIO,
        children: [
            {
                title: 'Customer Credit Transfer',
                url: `${APP_ROUTE_KEYS.TEST_CASES.MASTER}/cct`,
                key: 'scenario',
                icon: (isActive) => <ExpandIcon isActive={isActive} />,
                parentKey: 'testCases',
                disabled: false,
                privilege: menus.SCENARIO,
            },
            {
                title: 'Return Request',
                url: `${APP_ROUTE_KEYS.TEST_CASES.RETURN_REQUEST}/returnRequest`,
                key: 'returnRequest',
                icon: (isActive) => <ExpandIcon isActive={isActive} />,
                parentKey: 'testCases',
                disabled: false,
                privilege: menus.SCENARIO,
            },
            {
                title: 'Payment Return',
                url: `${APP_ROUTE_KEYS.TEST_CASES.PAYMENT_RETURN}/paymentReturn`,
                key: 'paymentReturn',
                icon: (isActive) => <ExpandIcon isActive={isActive} />,
                parentKey: 'testCases',
                disabled: false,
                privilege: menus.SCENARIO,
            },
            // {
            //     title: 'Payment Cancellation',
            //     url: `${APP_ROUTE_KEYS.TEST_CASES.PAYMENT_CANCELLATION}/PaymentCancellation`,
            //     key: 'PaymentCancellation',
            //     icon: (isActive) => <ExpandIcon isActive={isActive} />,
            //     parentKey: 'testCases',
            //     disabled: false,
            //     privilege: menus.SCENARIO,
            // },
            // {
            //     title: 'Payment Status Request',
            //     url: `${APP_ROUTE_KEYS.TEST_CASES.PAYMENT_STATUS_REQUEST}/PaymentStatusRequest`,
            //     key: 'PaymentStatusRequest',
            //     icon: (isActive) => <ExpandIcon isActive={isActive} />,
            //     parentKey: 'testCases',
            //     disabled: false,
            //     privilege: menus.SCENARIO,
            // },
            // {
            //     title: 'Request for Payment Response',
            //     url: `${APP_ROUTE_KEYS.TEST_CASES.REQUEST_FOR_PAYMENT_RESPONSE}/RequestForPaymentResponse`,
            //     key: 'RequestForPaymentResponse',
            //     icon: (isActive) => <ExpandIcon isActive={isActive} />,
            //     parentKey: 'testCases',
            //     disabled: false,
            //     privilege: menus.SCENARIO,
            // },
            // {
            //     title: 'Message Flows',
            //     url: `${APP_ROUTE_KEYS.TEST_CASES.MASTER}/MF`,
            //     key: 'testCases-MF',
            //     icon: (isActive) => <ExpandIcon isActive={isActive} />,
            //     parentKey: 'testCases',
            //     disabled: true,
            //     privilege: menus.TEST_CASES,
            // },
        ],
    },
    {
        title: 'Batches',
        url: `${APP_ROUTE_KEYS.BATCHES.MASTER}/cct`,
        key: 'batches',
        icon: (isActive) => <TestExecutionIcon isActive={isActive} />,
        disabled: false,
        privilege: menus.BATCHES
    },
    {
        title: 'Executions',
        icon: 'test-runs',
        key: 'testRuns',
        icon: (isActive) => <TestExecutionIcon isActive={isActive} />,
        disabled: false,
        privilege: menus.EXECUTIONS,
        children: [
            {
                title: 'Batch Execution Summary',
                url: `${APP_ROUTE_KEYS.TEST_RUNS.MASTER}/summary`,
                key: 'summary',
                icon: (isActive) => <ExpandIcon isActive={isActive} />,
                parentKey: 'testRuns',
                disabled: false,
                privilege: menus.EXECUTIONS,
            },
            {
                title: 'Test Execution Summary',
                url: `${APP_ROUTE_KEYS.TEST_RUNS.MASTER}/cct`,
                key: 'executions',
                icon: (isActive) => <ExpandIcon isActive={isActive} />,
                parentKey: 'testRuns',
                disabled: false,
                privilege: menus.EXECUTIONS,
            },
            // {
            //     title: 'Message Flows',
            //     url: `${APP_ROUTE_KEYS.TEST_RUNS.MASTER}/MF`,
            //     key: 'testRun-MF',
            //     icon: (isActive) => <ExpandIcon isActive={isActive} />,
            //     parentKey: 'testRuns',
            //     disabled: true,
            //     privilege: menus.TEST_EXECUTIONS,
            // },
        ]
    },
    {
        title: 'Settlement Account',
        url: `${APP_ROUTE_KEYS.SETTLEMENT.MASTER}`,
        key: 'settlement',
        icon: (isActive) => <SettlementIcon isActive={isActive} />,
        disabled: true,
        privilege: menus.SETTLEMENT_ACCOUNT,
    },
    {
        title: 'Users',
        url: `${APP_ROUTE_KEYS.USERS.MASTER}`,
        key: 'users',
        icon: (isActive) => <UsersIcon isActive={isActive} />,
        privilege: menus.USERS,
        // disabled: true
    },
    {
        title: 'Customers',
        url: `${APP_ROUTE_KEYS.CUSTOMERS.MASTER}`,
        key: 'customers',
        icon: (isActive) => <UsersIcon isActive={isActive} />,
        privilege: menus.CUSTOMERS,
        // disabled: true
    },
    {
        title: 'User Activity Logs',
        url: `${APP_ROUTE_KEYS.USER_AUDIT_LOG.MASTER}`,
        key: 'activityLogs',
        icon: (isActive) => <LogIcon isActive={isActive} />,
        privilege: menus.USER_AUDIT_LOG,
        // disabled: true
    },
    {
        title: 'Settings',
        url: `${APP_ROUTE_KEYS.SETTINGS.MASTER}`,
        key: 'settings',
        icon: (isActive) => <SettingsIcon isActive={isActive} />,
        // disabled: true,
        privilege: menus.SETTINGS,
    },
    {
        title: 'Master Test Cases',
        url: `${APP_ROUTE_KEYS.TEST_CASES_REPO.MASTER}`,
        key: 'mastertestcases',
        icon: (isActive) => <TestcasesIcon isActive={isActive} />,
        // disabled: true,
        privilege: menus.TEST_CASES_REPO,
    },
    {
        title: 'Upload Test Cases',
        url: `${APP_ROUTE_KEYS.UPLOAD_TESTCASE.MASTER}`,
        key: 'uploadtestcases',
        icon: (isActive) => <TestcasesIcon isActive={isActive} />,
        // disabled: true,
        privilege: menus.UPLOAD_TESTCASE,
    },
    {
        title: 'Pre-Requisite Data',
        url: `${APP_ROUTE_KEYS.PRE_REQUISITE_DATA.MASTER}`,
        key: 'prerequisitedatas',
        icon: (isActive) => <TestcasesIcon isActive={isActive} />,
        // disabled: true,
        privilege: menus.PRE_REQUISITE_DATA,
    },

]

export const testcaseFiles = [{
    name: 'testcase-1.xlsx',
    value: 'testcase1'
},
{
    name: 'testcase2.xlsx',
    value: 'testcase2'
}];

export const base64Data = {
    testcase1: testcase1,
    testcase2: testcase2,
    pasc002: pasc002,
    pasc004: pasc004,
    pasc008: pasc008,
    pain013: pain013,
    pain014: pain014
}

export const onboardingMenus = [{
    title: 'Choose',
    description: 'Subscription Plan',
    key: onboardingScreen.CHOOSE_SUBSCRIPTION,
}
    ,
{
    title: 'Select',
    description: 'Participation Type',
    key: onboardingScreen.SELECT_PARTICIPATION_TYPE
},
{
    title: 'Configure',
    description: 'Participation Type',
    key: onboardingScreen.CONFIGURE_PARTICIPATION_TYPE
}
    // ,
    // {
    //     title: 'Configure',
    //     description: 'Test Data',
    //     key: 'configureTestData'
    // },
    // {
    //     title: 'Simulator',
    //     description: 'Test Data',
    //     key: 'simulatorTestData'
    // }
]

export const messageTypes = [
    {
        messageId: 'pacs.002.001.12',
        messageName: 'FIToFIPaymentStatusReportV12',
        type: 'pasc',
        testcasesKey: 'pasc002',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.002.001.12" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.002.001.12">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIToFIPmtStsRpt" type="FIToFIPaymentStatusReportV12"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentGroupStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentTransactionStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalStatusReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FIToFIPaymentStatusReportV12">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader101"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="OrgnlGrpInfAndSts" type="OriginalGroupHeader17"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInfAndSts" type="PaymentTransaction130"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader101">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlBizQry" type="OriginalBusinessQuery1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NumberOfTransactionsPerStatus5">
                <xs:sequence>
                    <xs:element name="DtldNbOfTxs" type="Max15NumericText"/>
                    <xs:element name="DtldSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtldCtrlSum" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalBusinessQuery1">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CreDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalGroupHeader17">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpSts" type="ExternalPaymentGroupStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NbOfTxsPerSts" type="NumberOfTransactionsPerStatus5"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation29">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference35">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTransaction130">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="StsId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupInformation29"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptncDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FctvIntrBkSttlmDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AcctSvcrRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference35"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StatusReason6Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalStatusReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="StatusReasonInformation12">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="StatusReason6Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.003.001.09',
        messageName: 'FIToFICustomerDirectDebitV09',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.003.001.09" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.003.001.09">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DirectDebitTransaction11">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PreNtfctnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PreNtfctnDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DirectDebitTransactionInformation29">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification13"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element name="IntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRate" type="BaseOneRate"/>
                    <xs:element name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtTx" type="DirectDebitTransaction11"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RgltryRptg" type="RegulatoryReporting3"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RltdRmtInf" type="RemittanceLocation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIToFICstmrDrctDbt" type="FIToFICustomerDirectDebitV09"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FIToFICustomerDirectDebitV09">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader98"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="DrctDbtTxInf" type="DirectDebitTransactionInformation29"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader98">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element name="SttlmInf" type="SettlementInstruction14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NameAndAddress16">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element name="Adr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryAuthority2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtCdtRptgInd" type="RegulatoryReportingType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authrty" type="RegulatoryAuthority2"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="StructuredRegulatoryReporting3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RegulatoryReportingType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="BOTH"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtId" type="Max35Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RmtLctnDtls" type="RemittanceLocationData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocationData1">
                <xs:sequence>
                    <xs:element name="Mtd" type="RemittanceLocationMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="NameAndAddress16"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RemittanceLocationMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FAXI"/>
                    <xs:enumeration value="EDIC"/>
                    <xs:enumeration value="URID"/>
                    <xs:enumeration value="EMAL"/>
                    <xs:enumeration value="POST"/>
                    <xs:enumeration value="SMSM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction14">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StructuredRegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Max10Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Inf" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.004.001.11',
        messageName: 'PaymentReturnV11',
        type: 'pasc',
        testcasesKey: 'pasc004',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.004.001.11" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.004.001.11">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditTransferTransaction52">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForNxtAgt" type="InstructionForNextAgent1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="PmtRtr" type="PaymentReturnV11"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalReturnReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader99">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpRtr" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlRtrdIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOTime">
                <xs:restriction base="xs:time"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="Instruction4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="PHOA"/>
                    <xs:enumeration value="TELA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="InstructionForNextAgent1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Instruction4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupHeader18">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RtrRsnInf" type="PaymentReturnReason6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation29">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference36">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UndrlygCstmrCdtTrf" type="CreditTransferTransaction52"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentReturnReason6">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="ReturnReason5Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentReturnV11">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader99"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupHeader18"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInf" type="PaymentTransaction133"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTransaction133">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RtrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupInformation29"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlIntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlIntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element name="RtrdIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmReq" type="SettlementTimeRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RtrdInstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRate" type="BaseOneRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CompstnAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RtrChain" type="TransactionParties10"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RtrRsnInf" type="PaymentReturnReason6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference36"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation28">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReturnReason5Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalReturnReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="SettlementTimeRequest2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CLSTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TillTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RjctTm" type="ISOTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="TransactionParties10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.007.001.11',
        messageName: 'FIToFIPaymentReversalV11',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.007.001.11" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.007.001.11">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIToFIPmtRvsl" type="FIToFIPaymentReversalV11"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalReversalReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FIToFIPaymentReversalV11">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader97"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupHeader16"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInf" type="PaymentTransaction135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader97">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpRvsl" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlRvsdIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupHeader16">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RvslRsnInf" type="PaymentReversalReason9"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation29">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference35">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentReversalReason9">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="ReversalReason4Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTransaction135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RvslId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupInformation29"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlIntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="RvsdIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RvsdInstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRate" type="BaseOneRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CompstnAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RvslRsnInf" type="PaymentReversalReason9"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference35"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReversalReason4Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalReversalReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.008.001.10',
        messageName: 'FIToFICustomerCreditTransferV10',
        type: 'pasc',
        testcasesKey: 'pasc008',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.008.001.10" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.008.001.10">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditTransferTransaction50">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification13"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element name="IntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmReq" type="SettlementTimeRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptncDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PoolgAdjstmntDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRate" type="BaseOneRate"/>
                    <xs:element name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="CreditTransferMandateData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForNxtAgt" type="InstructionForNextAgent1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RgltryRptg" type="RegulatoryReporting3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RltdRmtInf" type="RemittanceLocation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIToFICstmrCdtTrf" type="FIToFICustomerCreditTransferV10"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FIToFICustomerCreditTransferV10">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader96"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="CdtTrfTxInf" type="CreditTransferTransaction50"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader96">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOTime">
                <xs:restriction base="xs:time"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="Instruction4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="PHOA"/>
                    <xs:enumeration value="TELA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="InstructionForNextAgent1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Instruction4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NameAndAddress16">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element name="Adr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation28">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryAuthority2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtCdtRptgInd" type="RegulatoryReportingType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authrty" type="RegulatoryAuthority2"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="StructuredRegulatoryReporting3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RegulatoryReportingType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="BOTH"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtId" type="Max35Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RmtLctnDtls" type="RemittanceLocationData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocationData1">
                <xs:sequence>
                    <xs:element name="Mtd" type="RemittanceLocationMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="NameAndAddress16"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RemittanceLocationMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FAXI"/>
                    <xs:enumeration value="EDIC"/>
                    <xs:enumeration value="URID"/>
                    <xs:enumeration value="EMAL"/>
                    <xs:enumeration value="POST"/>
                    <xs:enumeration value="SMSM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="SettlementTimeRequest2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CLSTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TillTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RjctTm" type="ISOTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Max10Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Inf" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.009.001.10',
        messageName: 'FinancialInstitutionCreditTransferV10',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.009.001.10" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.009.001.10">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferTransaction52">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForNxtAgt" type="InstructionForNextAgent1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditTransferTransaction56">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification13"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element name="IntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmReq" type="SettlementTimeRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvsInstgAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="Dbtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForNxtAgt" type="InstructionForNextAgent1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UndrlygCstmrCdtTrf" type="CreditTransferTransaction52"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FICdtTrf" type="FinancialInstitutionCreditTransferV10"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionCreditTransferV10">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader96"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="CdtTrfTxInf" type="CreditTransferTransaction56"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader96">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOTime">
                <xs:restriction base="xs:time"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="Instruction4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="PHOA"/>
                    <xs:enumeration value="TELA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="InstructionForNextAgent1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Instruction4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation28">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="SettlementTimeRequest2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CLSTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TillTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RjctTm" type="ISOTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.010.001.05',
        messageName: 'FinancialInstitutionDirectDebitV05',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.010.001.05" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.010.001.05">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferTransaction53">
                <xs:sequence>
                    <xs:element name="CdtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlIntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Cdtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="DrctDbtTxInf" type="DirectDebitTransactionInformation27"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DirectDebitTransactionInformation27">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification13"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation28"/>
                    <xs:element name="IntrBkSttlmAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmIndctn" type="SettlementDateTimeIndication1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmReq" type="SettlementTimeRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="Dbtr" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrForDbtrAgt" type="Max210Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIDrctDbt" type="FinancialInstitutionDirectDebitV05"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionDirectDebitV05">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader92"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="CdtInstr" type="CreditTransferTransaction53"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader92">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOTime">
                <xs:restriction base="xs:time"/>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max210Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="210"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation28">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementDateTimeIndication1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SettlementTimeRequest2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CLSTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TillTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RjctTm" type="ISOTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.028.001.05',
        messageName: 'FIToFIPaymentStatusRequestV05',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.20) on 2021 Feb 08 20:46:44, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.028.001.05" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.028.001.05">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="FIToFIPmtStsReq" type="FIToFIPaymentStatusRequestV05"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FIToFIPaymentStatusRequestV05">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader91"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupInformation27"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInf" type="PaymentTransaction131"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader91">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation27">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation29">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference35">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTransaction131">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="StsReqId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlGrpInf" type="OriginalGroupInformation29"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptncDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference35"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pacs.029.001.01',
        messageName: 'Multilateral Settlement',
        type: 'pasc',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.18) on 2021 Nov 10 12:22:57, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pacs.029.001.01" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pacs.029.001.01">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmountAndDirection5">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbt" type="CreditDebitCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="MulSttlmReq" type="MultilateralSettlementRequestV01"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader104">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element name="NbOfSttlmReqs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction14"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOTime">
                <xs:restriction base="xs:time"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MovementRecord1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element name="Amt" type="AmountAndDirection5"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAgt" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ptcpt" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PtcptAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MultilateralSettlementRequest2">
                <xs:sequence>
                    <xs:element name="InstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmTmReq" type="SettlementTimeRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmPrty" type="Priority3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmCycl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="NbOfMvmntRcrds" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="2" name="MvmntRcrd" type="MovementRecord1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MultilateralSettlementRequestV01">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader104"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="SttlmReq" type="MultilateralSettlementRequest2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="URGT"/>
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction14">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="SettlementTimeRequest2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CLSTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TillTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrTm" type="ISOTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RjctTm" type="ISOTime"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.001.001.11',
        messageName: 'CustomerCreditTransferInitiationV11',
        type: 'pain',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 20:44:59, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.001.001.11" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.001.001.11">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AdviceType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtAdvc" type="AdviceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtAdvc" type="AdviceType1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AdviceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AdviceType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AdviceType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADWD"/>
                    <xs:enumeration value="ADND"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Cheque11">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqTp" type="ChequeType2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqNb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqFr" type="NameAndAddress16"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DlvryMtd" type="ChequeDeliveryMethod1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DlvrTo" type="NameAndAddress16"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqMtrtyDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="MemoFld" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RgnlClrZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrtLctn" type="Max35Text"/>
                    <xs:element maxOccurs="5" minOccurs="0" name="Sgntr" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ChequeDelivery1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MLDB"/>
                    <xs:enumeration value="MLCD"/>
                    <xs:enumeration value="MLFA"/>
                    <xs:enumeration value="CRDB"/>
                    <xs:enumeration value="CRCD"/>
                    <xs:enumeration value="CRFA"/>
                    <xs:enumeration value="PUDB"/>
                    <xs:enumeration value="PUCD"/>
                    <xs:enumeration value="PUFA"/>
                    <xs:enumeration value="RGDB"/>
                    <xs:enumeration value="RGCD"/>
                    <xs:enumeration value="RGFA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ChequeDeliveryMethod1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ChequeDelivery1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChequeType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CCHQ"/>
                    <xs:enumeration value="CCCH"/>
                    <xs:enumeration value="BCHQ"/>
                    <xs:enumeration value="DRFT"/>
                    <xs:enumeration value="ELDR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditTransferTransaction54">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation26"/>
                    <xs:element name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRateInf" type="ExchangeRate1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="CreditTransferMandateData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqInstr" type="Cheque11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3Acct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrForDbtrAgt" type="InstructionForDebtorAgent1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RgltryRptg" type="RegulatoryReporting3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RltdRmtInf" type="RemittanceLocation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CustomerCreditTransferInitiationV11">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader95"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="PmtInf" type="PaymentInstruction40"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CstmrCdtTrfInitn" type="CustomerCreditTransferInitiationV11"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ExchangeRate1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="UnitCcy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRate" type="BaseOneRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RateTp" type="ExchangeRateType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrctId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ExchangeRateType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="SPOT"/>
                    <xs:enumeration value="SALE"/>
                    <xs:enumeration value="AGRD"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDebtorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader95">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FwdgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitnSrc" type="PaymentInitiationSource1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="InstructionForDebtorAgent1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalDebtorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NameAndAddress16">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element name="Adr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification6">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentInitiationSource1">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prvdr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Vrsn" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentInstruction40">
                <xs:sequence>
                    <xs:element name="PmtInfId" type="Max35Text"/>
                    <xs:element name="PmtMtd" type="PaymentMethod3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdAdvcTp" type="AdviceType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation26"/>
                    <xs:element name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PoolgAdjstmntDt" type="ISODate"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrForDbtrAgt" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgsAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgsAcctAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="CdtTrfTxInf" type="CreditTransferTransaction54"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTypeInformation26">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryAuthority2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtCdtRptgInd" type="RegulatoryReportingType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authrty" type="RegulatoryAuthority2"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="StructuredRegulatoryReporting3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RegulatoryReportingType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="BOTH"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtId" type="Max35Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RmtLctnDtls" type="RemittanceLocationData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocationData1">
                <xs:sequence>
                    <xs:element name="Mtd" type="RemittanceLocationMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="NameAndAddress16"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RemittanceLocationMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FAXI"/>
                    <xs:enumeration value="EDIC"/>
                    <xs:enumeration value="URID"/>
                    <xs:enumeration value="EMAL"/>
                    <xs:enumeration value="POST"/>
                    <xs:enumeration value="SMSM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="StructuredRegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Max10Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Inf" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.002.001.12',
        messageName: 'CustomerPaymentStatusReportV12',
        type: 'pain',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 20:44:59, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.002.001.12" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.002.001.12">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BaseOneRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CurrencyExchange13">
                <xs:sequence>
                    <xs:element name="SrcCcy" type="ActiveCurrencyCode"/>
                    <xs:element name="TrgtCcy" type="ActiveCurrencyCode"/>
                    <xs:element name="XchgRate" type="BaseOneRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UnitCcy" type="ActiveCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CustomerPaymentStatusReportV12">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader86"/>
                    <xs:element name="OrgnlGrpInfAndSts" type="OriginalGroupHeader17"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="OrgnlPmtInfAndSts" type="OriginalPaymentInstruction40"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CstmrPmtStsRpt" type="CustomerPaymentStatusReportV12"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentGroupStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentTransactionStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalStatusReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader86">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FwdgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NumberOfTransactionsPerStatus5">
                <xs:sequence>
                    <xs:element name="DtldNbOfTxs" type="Max15NumericText"/>
                    <xs:element name="DtldSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtldCtrlSum" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupHeader17">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpSts" type="ExternalPaymentGroupStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NbOfTxsPerSts" type="NumberOfTransactionsPerStatus5"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalPaymentInstruction40">
                <xs:sequence>
                    <xs:element name="OrgnlPmtInfId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtInfSts" type="ExternalPaymentGroupStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NbOfTxsPerSts" type="NumberOfTransactionsPerStatus5"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInfAndSts" type="PaymentTransaction129"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference35">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTransaction129">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="StsId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckrData" type="TrackerData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptncDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AcctSvcrRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference35"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StatusReason6Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalStatusReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="StatusReasonInformation12">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="StatusReason6Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="TrackerData1">
                <xs:sequence>
                    <xs:element name="ConfdDt" type="DateAndDateTime2Choice"/>
                    <xs:element name="ConfdAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="TrckrRcrd" type="TrackerRecord1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TrackerRecord1">
                <xs:sequence>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgsAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XchgRateData" type="CurrencyExchange13"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.007.001.11',
        messageName: 'CustomerPaymentReversalV11',
        type: 'pain',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 20:44:59, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.007.001.11" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.007.001.11">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ClearingChannel2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RTGS"/>
                    <xs:enumeration value="RTNS"/>
                    <xs:enumeration value="MPNS"/>
                    <xs:enumeration value="BOOK"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashClearingSystem1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CustomerPaymentReversalV11">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader88"/>
                    <xs:element name="OrgnlGrpInf" type="OriginalGroupHeader16"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="OrgnlPmtInfAndRvsl" type="OriginalPaymentInstruction41"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CstmrPmtRvsl" type="CustomerPaymentReversalV11"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashClearingSystem1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="3"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalReversalReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader88">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpRvsl" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FwdgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateRelatedData2Choice">
                <xs:choice>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtMndt" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtTrfMndt" type="CreditTransferMandateData1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupHeader16">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RvslRsnInf" type="PaymentReversalReason9"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalPaymentInstruction41">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RvslPmtInfId" type="Max35Text"/>
                    <xs:element name="OrgnlPmtInfId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtInfRvsl" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RvslRsnInf" type="PaymentReversalReason9"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInf" type="PaymentTransaction134"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference35">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrBkSttlmDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmInf" type="SettlementInstruction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation27"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedData2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="Party40Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Party40Choice">
                <xs:choice>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentReversalReason9">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="ReversalReason4Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTransaction134">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RvslId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RvsdInstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RvslRsnInf" type="PaymentReversalReason9"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference35"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation27">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrChanl" type="ClearingChannel2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReversalReason4Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalReversalReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SettlementInstruction11">
                <xs:sequence>
                    <xs:element name="SttlmMtd" type="SettlementMethod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SttlmAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSys" type="ClearingSystemIdentification3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstgRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstdRmbrsmntAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ThrdRmbrsmntAgtAcct" type="CashAccount40"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="SettlementMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="INGA"/>
                    <xs:enumeration value="COVE"/>
                    <xs:enumeration value="CLRG"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.008.001.10',
        messageName: 'CustomerDirectDebitInitiationV10',
        type: 'pain',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 20:44:59, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.008.001.10" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.008.001.10">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AdviceType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtAdvc" type="AdviceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtAdvc" type="AdviceType1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AdviceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AdviceType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AdviceType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADWD"/>
                    <xs:enumeration value="ADND"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AmendmentInformationDetails14">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlMndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlDbtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlFrqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlRsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Authorisation1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="Authorisation1Code"/>
                    <xs:element name="Prtry" type="Max128Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Authorisation1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="AUTH"/>
                    <xs:enumeration value="FDET"/>
                    <xs:enumeration value="FSUM"/>
                    <xs:enumeration value="ILEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BatchBookingIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CustomerDirectDebitInitiationV10">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader83"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="PmtInf" type="PaymentInstruction39"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DirectDebitTransaction11">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="MandateRelatedInformation15"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PreNtfctnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PreNtfctnDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DirectDebitTransactionInformation28">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation29"/>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DrctDbtTx" type="DirectDebitTransaction11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgtAcct" type="CashAccount40"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrForCdtrAgt" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RgltryRptg" type="RegulatoryReporting3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RltdRmtInf" type="RemittanceLocation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CstmrDrctDbtInitn" type="CustomerDirectDebitInitiationV10"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader83">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="Authstn" type="Authorisation1Choice"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FwdgAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateRelatedInformation15">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AmdmntInfDtls" type="AmendmentInformationDetails14"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max1025Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlColltnDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TrckgDays" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Max1025Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="1025"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NameAndAddress16">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element name="Adr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification6">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentInstruction39">
                <xs:sequence>
                    <xs:element name="PmtInfId" type="Max35Text"/>
                    <xs:element name="PmtMtd" type="PaymentMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdAdvcTp" type="AdviceType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BtchBookg" type="BatchBookingIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation29"/>
                    <xs:element name="ReqdColltnDt" type="ISODate"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element name="CdtrAcct" type="CashAccount40"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgtAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgsAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgsAcctAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrSchmeId" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="DrctDbtTxInf" type="DirectDebitTransactionInformation28"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DD"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTypeInformation29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqTp" type="SequenceType3Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryAuthority2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtCdtRptgInd" type="RegulatoryReportingType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authrty" type="RegulatoryAuthority2"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="StructuredRegulatoryReporting3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RegulatoryReportingType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="BOTH"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtId" type="Max35Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RmtLctnDtls" type="RemittanceLocationData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocationData1">
                <xs:sequence>
                    <xs:element name="Mtd" type="RemittanceLocationMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="NameAndAddress16"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RemittanceLocationMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FAXI"/>
                    <xs:enumeration value="EDIC"/>
                    <xs:enumeration value="URID"/>
                    <xs:enumeration value="EMAL"/>
                    <xs:enumeration value="POST"/>
                    <xs:enumeration value="SMSM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="SequenceType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FRST"/>
                    <xs:enumeration value="RCUR"/>
                    <xs:enumeration value="FNAL"/>
                    <xs:enumeration value="OOFF"/>
                    <xs:enumeration value="RPRE"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="StructuredRegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Max10Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Inf" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.013.001.09',
        messageName: 'CreditorPaymentActivationRequestV09',
        type: 'pain',
        testcasesKey: 'pain013',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 21:18:42, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.013.001.09" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.013.001.09">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AdviceType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtAdvc" type="AdviceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtAdvc" type="AdviceType1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="AdviceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AdviceType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AdviceType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADWD"/>
                    <xs:enumeration value="ADND"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AmountOrRate1Choice">
                <xs:choice>
                    <xs:element name="Amt" type="ActiveCurrencyAndAmount"/>
                    <xs:element name="Rate" type="PercentageRate"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChargeBearerType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="SHAR"/>
                    <xs:enumeration value="SLEV"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="Cheque11">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqTp" type="ChequeType2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqNb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqFr" type="NameAndAddress16"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DlvryMtd" type="ChequeDeliveryMethod1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DlvrTo" type="NameAndAddress16"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqMtrtyDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="2" minOccurs="0" name="MemoFld" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RgnlClrZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrtLctn" type="Max35Text"/>
                    <xs:element maxOccurs="5" minOccurs="0" name="Sgntr" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="ChequeDelivery1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MLDB"/>
                    <xs:enumeration value="MLCD"/>
                    <xs:enumeration value="MLFA"/>
                    <xs:enumeration value="CRDB"/>
                    <xs:enumeration value="CRCD"/>
                    <xs:enumeration value="CRFA"/>
                    <xs:enumeration value="PUDB"/>
                    <xs:enumeration value="PUCD"/>
                    <xs:enumeration value="PUFA"/>
                    <xs:enumeration value="RGDB"/>
                    <xs:enumeration value="RGCD"/>
                    <xs:enumeration value="RGFA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ChequeDeliveryMethod1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ChequeDelivery1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ChequeType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CCHQ"/>
                    <xs:enumeration value="CCCH"/>
                    <xs:enumeration value="BCHQ"/>
                    <xs:enumeration value="DRFT"/>
                    <xs:enumeration value="ELDR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditTransferTransaction55">
                <xs:sequence>
                    <xs:element name="PmtId" type="PaymentIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation26"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtCond" type="PaymentCondition1"/>
                    <xs:element name="Amt" type="AmountType4Choice"/>
                    <xs:element name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="CreditTransferMandateData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChqInstr" type="Cheque11"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt1" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt2" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="IntrmyAgt3" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="InstrForCdtrAgt" type="InstructionForCreditorAgent3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Purp" type="Purpose2Choice"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RgltryRptg" type="RegulatoryReporting3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tax" type="TaxInformation10"/>
                    <xs:element maxOccurs="10" minOccurs="0" name="RltdRmtInf" type="RemittanceLocation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NclsdFile" type="Document12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorPaymentActivationRequestV09">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader78"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="PmtInf" type="PaymentInstruction41"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CdtrPmtActvtnReq" type="CreditorPaymentActivationRequestV09"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Document12">
                <xs:sequence>
                    <xs:element name="Tp" type="DocumentType1Choice"/>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element name="IsseDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LangCd" type="LanguageCode"/>
                    <xs:element name="Frmt" type="DocumentFormat1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FileNm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DgtlSgntr" type="PartyAndSignature3"/>
                    <xs:element name="Nclsr" type="Max10MbBinary"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentFormat1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentFormat1Code"/>
                    <xs:element name="Prtry" type="GenericIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DocumentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentType1Code"/>
                    <xs:element name="Prtry" type="GenericIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCreditorAgentInstruction1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentFormat1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader78">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element name="NbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrlSum" type="DecimalNumber"/>
                    <xs:element name="InitgPty" type="PartyIdentification135"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:complexType name="InstructionForCreditorAgent3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="ExternalCreditorAgentInstruction1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="LanguageCode">
                <xs:restriction base="xs:string"/>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10MbBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10485760"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NameAndAddress16">
                <xs:sequence>
                    <xs:element name="Nm" type="Max140Text"/>
                    <xs:element name="Adr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyAndSignature3">
                <xs:sequence>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Sgntr" type="SkipPayload"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentCondition1">
                <xs:sequence>
                    <xs:element name="AmtModAllwd" type="TrueFalseIndicator"/>
                    <xs:element name="EarlyPmtAllwd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DelyPnlty" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ImdtPmtRbt" type="AmountOrRate1Choice"/>
                    <xs:element name="GrntedPmtReqd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentIdentification6">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrId" type="Max35Text"/>
                    <xs:element name="EndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UETR" type="UUIDv4Identifier"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentInstruction41">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtInfId" type="Max35Text"/>
                    <xs:element name="PmtMtd" type="PaymentMethod7Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdAdvcTp" type="AdviceType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation26"/>
                    <xs:element name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XpryDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtCond" type="PaymentCondition1"/>
                    <xs:element name="Dbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ChrgBr" type="ChargeBearerType1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="CdtTrfTx" type="CreditTransferTransaction55"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod7Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTypeInformation26">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Purpose2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryAuthority2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtCdtRptgInd" type="RegulatoryReportingType1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authrty" type="RegulatoryAuthority2"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="StructuredRegulatoryReporting3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RegulatoryReportingType1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRED"/>
                    <xs:enumeration value="DEBT"/>
                    <xs:enumeration value="BOTH"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtId" type="Max35Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RmtLctnDtls" type="RemittanceLocationData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceLocationData1">
                <xs:sequence>
                    <xs:element name="Mtd" type="RemittanceLocationMethod2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="NameAndAddress16"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="RemittanceLocationMethod2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FAXI"/>
                    <xs:enumeration value="EDIC"/>
                    <xs:enumeration value="URID"/>
                    <xs:enumeration value="EMAL"/>
                    <xs:enumeration value="POST"/>
                    <xs:enumeration value="SMSM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SkipPayload">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="skip"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRegulatoryReporting3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cd" type="Max10Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Inf" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxInformation10">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
    {
        messageId: 'pain.014.001.09',
        messageName: 'CreditorPaymentActivationRequestStatusReportV09',
        type: 'pain',
        testcasesKey: 'pain014',
        messageDetails: `<?xml version="1.0" encoding="UTF-8"?>
        <!--Generated by Standards Editor (build:R1.6.16) on 2021 Feb 16 21:18:42, ISO 20022 version : 2013-->
        <xs:schema xmlns="urn:iso:std:iso:20022:tech:xsd:pain.014.001.09" xmlns:xs="http://www.w3.org/2001/XMLSchema" elementFormDefault="qualified" targetNamespace="urn:iso:std:iso:20022:tech:xsd:pain.014.001.09">
            <xs:element name="Document" type="Document"/>
            <xs:complexType name="AccountIdentification4Choice">
                <xs:choice>
                    <xs:element name="IBAN" type="IBAN2007Identifier"/>
                    <xs:element name="Othr" type="GenericAccountIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AccountSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalAccountIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="5"/>
                    <xs:totalDigits value="18"/>
                    <xs:minInclusive value="0"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ActiveOrHistoricCurrencyAndAmount">
                <xs:simpleContent>
                    <xs:extension base="ActiveOrHistoricCurrencyAndAmount_SimpleType">
                        <xs:attribute name="Ccy" type="ActiveOrHistoricCurrencyCode" use="required"/>
                    </xs:extension>
                </xs:simpleContent>
            </xs:complexType>
            <xs:simpleType name="ActiveOrHistoricCurrencyCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{3,3}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="AddressType2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="ADDR"/>
                    <xs:enumeration value="PBOX"/>
                    <xs:enumeration value="HOME"/>
                    <xs:enumeration value="BIZZ"/>
                    <xs:enumeration value="MLTO"/>
                    <xs:enumeration value="DLVY"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="AddressType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="AddressType2Code"/>
                    <xs:element name="Prtry" type="GenericIdentification30"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmountOrRate1Choice">
                <xs:choice>
                    <xs:element name="Amt" type="ActiveCurrencyAndAmount"/>
                    <xs:element name="Rate" type="PercentageRate"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="AmountType4Choice">
                <xs:choice>
                    <xs:element name="InstdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="EqvtAmt" type="EquivalentAmount2"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="AnyBICDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="BICFIDec2014Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{4,4}[A-Z]{2,2}[A-Z0-9]{2,2}([A-Z0-9]{3,3}){0,1}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="BranchAndFinancialInstitutionIdentification6">
                <xs:sequence>
                    <xs:element name="FinInstnId" type="FinancialInstitutionIdentification18"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BrnchId" type="BranchData3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="BranchData3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccount40">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="AccountIdentification4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CashAccountType2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ccy" type="ActiveOrHistoricCurrencyCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prxy" type="ProxyAccountIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CashAccountType2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCashAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CategoryPurpose1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalCategoryPurpose1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Charges7">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="Agt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ClearingSystemIdentification2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalClearingSystemIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ClearingSystemMemberIdentification2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysId" type="ClearingSystemIdentification2Choice"/>
                    <xs:element name="MmbId" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Contact4">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="NmPrfx" type="NamePrefix2Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PhneNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MobNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FaxNb" type="PhoneNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailAdr" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="EmailPurp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="JobTitl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rspnsblty" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="OtherContact1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrefrdMtd" type="PreferredContactMethod1Code"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="CountryCode">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="CreditDebitCode">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CRDT"/>
                    <xs:enumeration value="DBIT"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="CreditTransferMandateData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="MandateTypeInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfSgntr" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtOfVrfctn" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ElctrncSgntr" type="Max10KBinary"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrstPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FnlPmtDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Frqcy" type="Frequency36Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="MandateSetupReason1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorPaymentActivationRequestStatusReportV09">
                <xs:sequence>
                    <xs:element name="GrpHdr" type="GroupHeader87"/>
                    <xs:element name="OrgnlGrpInfAndSts" type="OriginalGroupInformation30"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="OrgnlPmtInfAndSts" type="OriginalPaymentInstruction42"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="CreditorReferenceType2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ref" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType3Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="CreditorReferenceType2">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="CreditorReferenceType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DateAndDateTime2Choice">
                <xs:choice>
                    <xs:element name="Dt" type="ISODate"/>
                    <xs:element name="DtTm" type="ISODateTime"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DateAndPlaceOfBirth1">
                <xs:sequence>
                    <xs:element name="BirthDt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PrvcOfBirth" type="Max35Text"/>
                    <xs:element name="CityOfBirth" type="Max35Text"/>
                    <xs:element name="CtryOfBirth" type="CountryCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DatePeriod2">
                <xs:sequence>
                    <xs:element name="FrDt" type="ISODate"/>
                    <xs:element name="ToDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="DecimalNumber">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="17"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="DiscountAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DiscountAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DiscountAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDiscountAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="Document">
                <xs:sequence>
                    <xs:element name="CdtrPmtActvtnReqStsRpt" type="CreditorPaymentActivationRequestStatusReportV09"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Document12">
                <xs:sequence>
                    <xs:element name="Tp" type="DocumentType1Choice"/>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element name="IsseDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LangCd" type="LanguageCode"/>
                    <xs:element name="Frmt" type="DocumentFormat1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FileNm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DgtlSgntr" type="PartyAndSignature3"/>
                    <xs:element name="Nclsr" type="Max10MbBinary"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentAdjustment1">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtDbtInd" type="CreditDebitCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentFormat1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentFormat1Code"/>
                    <xs:element name="Prtry" type="GenericIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DocumentLineIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="DocumentLineType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineInformation1">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="1" name="Id" type="DocumentLineIdentification1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Desc" type="Max2048Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="RemittanceAmount3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="DocumentLineType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="DocumentLineType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentLineType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="DocumentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalDocumentType1Code"/>
                    <xs:element name="Prtry" type="GenericIdentification1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="DocumentType3Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="RADM"/>
                    <xs:enumeration value="RPIN"/>
                    <xs:enumeration value="FXDR"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="PUOR"/>
                    <xs:enumeration value="SCOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="DocumentType6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MSIN"/>
                    <xs:enumeration value="CNFA"/>
                    <xs:enumeration value="DNFA"/>
                    <xs:enumeration value="CINV"/>
                    <xs:enumeration value="CREN"/>
                    <xs:enumeration value="DEBN"/>
                    <xs:enumeration value="HIRI"/>
                    <xs:enumeration value="SBIN"/>
                    <xs:enumeration value="CMCN"/>
                    <xs:enumeration value="SOAC"/>
                    <xs:enumeration value="DISP"/>
                    <xs:enumeration value="BOLD"/>
                    <xs:enumeration value="VCHR"/>
                    <xs:enumeration value="AROI"/>
                    <xs:enumeration value="TSUT"/>
                    <xs:enumeration value="PUOR"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="EquivalentAmount2">
                <xs:sequence>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element name="CcyOfTrf" type="ActiveOrHistoricCurrencyCode"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Exact2NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Exact4AlphaNumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-zA-Z0-9]{4}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalAccountIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCashAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalCategoryPurpose1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalClearingSystemIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="5"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDiscountAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentFormat1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentLineType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalDocumentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalFinancialInstitutionIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalGarnishmentType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalLocalInstrument1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalMandateSetupReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalOrganisationIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentGroupStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPaymentTransactionStatus1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalPersonIdentification1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalProxyAccountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalServiceLevel1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalStatusReason1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ExternalTaxAmountType1Code">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FinancialIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalFinancialInstitutionIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="FinancialInstitutionIdentification18">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="BICFI" type="BICFIDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysMmbId" type="ClearingSystemMemberIdentification2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Othr" type="GenericFinancialIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Frequency36Choice">
                <xs:choice>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="Prd" type="FrequencyPeriod1"/>
                    <xs:element name="PtInTm" type="FrequencyAndMoment1"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="Frequency6Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="YEAR"/>
                    <xs:enumeration value="MNTH"/>
                    <xs:enumeration value="QURT"/>
                    <xs:enumeration value="MIAN"/>
                    <xs:enumeration value="WEEK"/>
                    <xs:enumeration value="DAIL"/>
                    <xs:enumeration value="ADHO"/>
                    <xs:enumeration value="INDA"/>
                    <xs:enumeration value="FRTN"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="FrequencyAndMoment1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="PtInTm" type="Exact2NumericText"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="FrequencyPeriod1">
                <xs:sequence>
                    <xs:element name="Tp" type="Frequency6Code"/>
                    <xs:element name="CntPerPrd" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Garnishment3">
                <xs:sequence>
                    <xs:element name="Tp" type="GarnishmentType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Grnshee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtAdmstr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FmlyMdclInsrncInd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MplyeeTermntnInd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="GarnishmentType1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GarnishmentType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalGarnishmentType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="GenericAccountIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max34Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="AccountSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericFinancialIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="FinancialIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericIdentification30">
                <xs:sequence>
                    <xs:element name="Id" type="Exact4AlphaNumericText"/>
                    <xs:element name="Issr" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericOrganisationIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="OrganisationIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GenericPersonIdentification1">
                <xs:sequence>
                    <xs:element name="Id" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SchmeNm" type="PersonIdentificationSchemeName1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="GroupHeader87">
                <xs:sequence>
                    <xs:element name="MsgId" type="Max35Text"/>
                    <xs:element name="CreDtTm" type="ISODateTime"/>
                    <xs:element name="InitgPty" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="IBAN2007Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z]{2,2}[0-9]{2,2}[a-zA-Z0-9]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="ISODate">
                <xs:restriction base="xs:date"/>
            </xs:simpleType>
            <xs:simpleType name="ISODateTime">
                <xs:restriction base="xs:dateTime"/>
            </xs:simpleType>
            <xs:simpleType name="ISOYear">
                <xs:restriction base="xs:gYear"/>
            </xs:simpleType>
            <xs:simpleType name="LEIIdentifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[A-Z0-9]{18,18}[0-9]{2,2}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="LanguageCode">
                <xs:restriction base="xs:string"/>
            </xs:simpleType>
            <xs:complexType name="LocalInstrument2Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalLocalInstrument1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateClassification1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="MandateClassification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="MandateClassification1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="FIXE"/>
                    <xs:enumeration value="USGB"/>
                    <xs:enumeration value="VARI"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="MandateSetupReason1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalMandateSetupReason1Code"/>
                    <xs:element name="Prtry" type="Max70Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="MandateTypeInformation2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Clssfctn" type="MandateClassification1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="Max105Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="105"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10KBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10240"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max10MbBinary">
                <xs:restriction base="xs:base64Binary">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="10485760"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max128Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="128"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max140Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="140"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max15NumericText">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[0-9]{1,15}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max16Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="16"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max2048Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="2048"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max34Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="34"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max350Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="350"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max35Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="35"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max4Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="4"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Max70Text">
                <xs:restriction base="xs:string">
                    <xs:minLength value="1"/>
                    <xs:maxLength value="70"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="NamePrefix2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="DOCT"/>
                    <xs:enumeration value="MADM"/>
                    <xs:enumeration value="MISS"/>
                    <xs:enumeration value="MIST"/>
                    <xs:enumeration value="MIKS"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Number">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="0"/>
                    <xs:totalDigits value="18"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="NumberOfTransactionsPerStatus5">
                <xs:sequence>
                    <xs:element name="DtldNbOfTxs" type="Max15NumericText"/>
                    <xs:element name="DtldSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtldCtrlSum" type="DecimalNumber"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentification29">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AnyBIC" type="AnyBICDec2014Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LEI" type="LEIIdentifier"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericOrganisationIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OrganisationIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalOrganisationIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="OriginalGroupInformation30">
                <xs:sequence>
                    <xs:element name="OrgnlMsgId" type="Max35Text"/>
                    <xs:element name="OrgnlMsgNmId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCreDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrpSts" type="ExternalPaymentGroupStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NbOfTxsPerSts" type="NumberOfTransactionsPerStatus5"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalPaymentInstruction42">
                <xs:sequence>
                    <xs:element name="OrgnlPmtInfId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlNbOfTxs" type="Max15NumericText"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlCtrlSum" type="DecimalNumber"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtInfSts" type="ExternalPaymentGroupStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NbOfTxsPerSts" type="NumberOfTransactionsPerStatus5"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TxInfAndSts" type="PaymentTransaction136"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OriginalTransactionReference37">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Amt" type="AmountType4Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ReqdExctnDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="XpryDt" type="DateAndDateTime2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtCond" type="PaymentCondition1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtTpInf" type="PaymentTypeInformation26"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtMtd" type="PaymentMethod4Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="MndtRltdInf" type="CreditTransferMandateData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtInf" type="RemittanceInformation21"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NclsdFile" type="Document12"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="CdtrAgt" type="BranchAndFinancialInstitutionIdentification6"/>
                    <xs:element name="Cdtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrAcct" type="CashAccount40"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtCdtr" type="PartyIdentification135"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="OtherContact1">
                <xs:sequence>
                    <xs:element name="ChanlTp" type="Max4Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Max128Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="Party38Choice">
                <xs:choice>
                    <xs:element name="OrgId" type="OrganisationIdentification29"/>
                    <xs:element name="PrvtId" type="PersonIdentification13"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="PartyAndSignature3">
                <xs:sequence>
                    <xs:element name="Pty" type="PartyIdentification135"/>
                    <xs:element name="Sgntr" type="SkipPayload"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PartyIdentification135">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstlAdr" type="PostalAddress24"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Id" type="Party38Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtryOfRes" type="CountryCode"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtctDtls" type="Contact4"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentCondition1">
                <xs:sequence>
                    <xs:element name="AmtModAllwd" type="TrueFalseIndicator"/>
                    <xs:element name="EarlyPmtAllwd" type="TrueFalseIndicator"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DelyPnlty" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ImdtPmtRbt" type="AmountOrRate1Choice"/>
                    <xs:element name="GrntedPmtReqd" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentConditionStatus1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptdAmt" type="ActiveCurrencyAndAmount"/>
                    <xs:element name="GrntedPmt" type="TrueFalseIndicator"/>
                    <xs:element name="EarlyPmt" type="TrueFalseIndicator"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PaymentMethod4Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="CHK"/>
                    <xs:enumeration value="TRF"/>
                    <xs:enumeration value="DD"/>
                    <xs:enumeration value="TRA"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PaymentTransaction136">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="StsId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlInstrId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlEndToEndId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlUETR" type="UUIDv4Identifier"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TxSts" type="ExternalPaymentTransactionStatus1Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="StsRsnInf" type="StatusReasonInformation12"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PmtCondSts" type="PaymentConditionStatus1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="ChrgsInf" type="Charges7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrDcsnDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AccptncDtTm" type="ISODateTime"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AcctSvcrRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="ClrSysRef" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="OrgnlTxRef" type="OriginalTransactionReference37"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="NclsdFile" type="Document12"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SplmtryData" type="SupplementaryData1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PaymentTypeInformation26">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="InstrPrty" type="Priority2Code"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="SvcLvl" type="ServiceLevel8Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="LclInstrm" type="LocalInstrument2Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyPurp" type="CategoryPurpose1Choice"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PercentageRate">
                <xs:restriction base="xs:decimal">
                    <xs:fractionDigits value="10"/>
                    <xs:totalDigits value="11"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PersonIdentification13">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DtAndPlcOfBirth" type="DateAndPlaceOfBirth1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Othr" type="GenericPersonIdentification1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="PersonIdentificationSchemeName1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalPersonIdentification1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:simpleType name="PhoneNumber">
                <xs:restriction base="xs:string">
                    <xs:pattern value="\+[0-9]{1,3}-[0-9()+\-]{1,30}"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="PostalAddress24">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdrTp" type="AddressType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SubDept" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="StrtNm" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNb" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="BldgNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Flr" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstBx" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Room" type="Max70Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="PstCd" type="Max16Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TwnLctnNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DstrctNm" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtrySubDvsn" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctry" type="CountryCode"/>
                    <xs:element maxOccurs="7" minOccurs="0" name="AdrLine" type="Max70Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="PreferredContactMethod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="LETT"/>
                    <xs:enumeration value="MAIL"/>
                    <xs:enumeration value="PHON"/>
                    <xs:enumeration value="FAXX"/>
                    <xs:enumeration value="CELL"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="Priority2Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="HIGH"/>
                    <xs:enumeration value="NORM"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:complexType name="ProxyAccountIdentification1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ProxyAccountType1Choice"/>
                    <xs:element name="Id" type="Max2048Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ProxyAccountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalProxyAccountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentInformation7">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="ReferredDocumentType4"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nb" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RltdDt" type="ISODate"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="LineDtls" type="DocumentLineInformation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType3Choice">
                <xs:choice>
                    <xs:element name="Cd" type="DocumentType6Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="ReferredDocumentType4">
                <xs:sequence>
                    <xs:element name="CdOrPrtry" type="ReferredDocumentType3Choice"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Issr" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="DuePyblAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="DscntApldAmt" type="DiscountAmountAndType1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtNoteAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="TaxAmt" type="TaxAmountAndType1"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AdjstmntAmtAndRsn" type="DocumentAdjustment1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RmtdAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="RemittanceInformation21">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Ustrd" type="Max140Text"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Strd" type="StructuredRemittanceInformation17"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="ServiceLevel8Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalServiceLevel1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="SkipPayload">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="skip"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StatusReason6Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalStatusReason1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="StatusReasonInformation12">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Orgtr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rsn" type="StatusReason6Choice"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="AddtlInf" type="Max105Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="StructuredRemittanceInformation17">
                <xs:sequence>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="RfrdDocInf" type="ReferredDocumentInformation7"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RfrdDocAmt" type="RemittanceAmount2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CdtrRefInf" type="CreditorReferenceInformation2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcr" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Invcee" type="PartyIdentification135"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxRmt" type="TaxData1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="GrnshmtRmt" type="Garnishment3"/>
                    <xs:element maxOccurs="3" minOccurs="0" name="AddtlRmtInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="PlcAndNm" type="Max350Text"/>
                    <xs:element name="Envlp" type="SupplementaryDataEnvelope1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="SupplementaryDataEnvelope1">
                <xs:sequence>
                    <xs:any namespace="##any" processContents="lax"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmount3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Rate" type="PercentageRate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Dtls" type="TaxRecordDetails3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountAndType1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxAmountType1Choice"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxAmountType1Choice">
                <xs:choice>
                    <xs:element name="Cd" type="ExternalTaxAmountType1Code"/>
                    <xs:element name="Prtry" type="Max35Text"/>
                </xs:choice>
            </xs:complexType>
            <xs:complexType name="TaxAuthorisation1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Titl" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Nm" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxData1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Cdtr" type="TaxParty1"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="UltmtDbtr" type="TaxParty2"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AdmstnZone" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RefNb" type="Max140Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Mtd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxblBaseAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TtlTaxAmt" type="ActiveOrHistoricCurrencyAndAmount"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Dt" type="ISODate"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="SeqNb" type="Number"/>
                    <xs:element maxOccurs="unbounded" minOccurs="0" name="Rcrd" type="TaxRecord3"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty1">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxParty2">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="RegnId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxTp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Authstn" type="TaxAuthorisation1"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxPeriod3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Yr" type="ISOYear"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="TaxRecordPeriod1Code"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrToDt" type="DatePeriod2"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecord3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Tp" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Ctgy" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CtgyDtls" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="DbtrSts" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="CertId" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="FrmsCd" type="Max35Text"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="TaxAmt" type="TaxAmount3"/>
                    <xs:element maxOccurs="1" minOccurs="0" name="AddtlInf" type="Max140Text"/>
                </xs:sequence>
            </xs:complexType>
            <xs:complexType name="TaxRecordDetails3">
                <xs:sequence>
                    <xs:element maxOccurs="1" minOccurs="0" name="Prd" type="TaxPeriod3"/>
                    <xs:element name="Amt" type="ActiveOrHistoricCurrencyAndAmount"/>
                </xs:sequence>
            </xs:complexType>
            <xs:simpleType name="TaxRecordPeriod1Code">
                <xs:restriction base="xs:string">
                    <xs:enumeration value="MM01"/>
                    <xs:enumeration value="MM02"/>
                    <xs:enumeration value="MM03"/>
                    <xs:enumeration value="MM04"/>
                    <xs:enumeration value="MM05"/>
                    <xs:enumeration value="MM06"/>
                    <xs:enumeration value="MM07"/>
                    <xs:enumeration value="MM08"/>
                    <xs:enumeration value="MM09"/>
                    <xs:enumeration value="MM10"/>
                    <xs:enumeration value="MM11"/>
                    <xs:enumeration value="MM12"/>
                    <xs:enumeration value="QTR1"/>
                    <xs:enumeration value="QTR2"/>
                    <xs:enumeration value="QTR3"/>
                    <xs:enumeration value="QTR4"/>
                    <xs:enumeration value="HLF1"/>
                    <xs:enumeration value="HLF2"/>
                </xs:restriction>
            </xs:simpleType>
            <xs:simpleType name="TrueFalseIndicator">
                <xs:restriction base="xs:boolean"/>
            </xs:simpleType>
            <xs:simpleType name="UUIDv4Identifier">
                <xs:restriction base="xs:string">
                    <xs:pattern value="[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}"/>
                </xs:restriction>
            </xs:simpleType>
        </xs:schema>
        `
    },
]

export const standaloneMessageTypes = [
    {
        messageType: 'PACS.008',
        messageDescription: 'Customer Credit Transfer',
        direction: 'SEND',
        status: 'Completed',
        messageId: 'pacs008'
    },
    {
        messageType: 'PACS.008',
        messageDescription: 'Customer Credit Transfer',
        direction: 'RECEIVE',
        status: '',
        messageId: 'pacs0082'
    },
    {
        messageType: 'PACS.002',
        messageDescription: 'Payment Status Report',
        direction: 'SEND',
        status: '',
        messageId: 'pacs002'
    },
    {
        messageType: 'PACS.004',
        messageDescription: 'Payment Status Report',
        direction: 'SEND',
        status: '',
        messageId: 'pacs004'
    },
    {
        messageType: 'PACS.028',
        messageDescription: 'Payment Status Report',
        direction: 'SEND',
        status: '',
        messageId: 'pacs028'
    },
    {
        messageType: 'PACS.009',
        messageDescription: 'Payment Status Report',
        direction: 'SEND',
        status: '',
        messageId: 'pacs009'
    },
    {
        messageType: 'CAMT.060',
        messageDescription: 'Payment Status Report',
        direction: 'SEND',
        status: '',
        messageId: 'camt060'
    }
]

export const messageTestCases = [
    {
        testcaseName: 'Pacs008-ACCC',
        testcaseDescription: 'Send pacs.008 message',
        message: 'PACS.008',
        direction: 'SEND',
        lastRun: '12/01/23',
        status: 'Success',
        logs: 'file',
    },
    {
        testcaseName: 'Pacs008-ACSC',
        testcaseDescription: 'Send pacs.008 message',
        message: 'PACS.008',
        direction: 'SEND',
        lastRun: '13/01/23',
        status: 'Fail',
        logs: 'file',
    },
    {
        testcaseName: 'Pacs008-RJCT',
        testcaseDescription: 'Send pacs.008 message',
        message: 'PACS.008',
        direction: 'SEND',
        lastRun: '',
        status: '',
        logs: '',
    }
];

export const directionTagColor = {
    'SEND': 'blue',
    'RECEIVE': 'magenta'
}

export const statusTagColor = {
    'Success': 'green',
    'Fail': 'red',
    'Completed': 'green',
}

export const subscriptionPlans = [
    {
        plan: 'Subscription Plan A',
        planKey: 'planA',
        planDescription: 'Exercitationem voluptas consequuntur repellendus eaut.',
        planDetails: {
            info: 'Non itaque voluptates. Et consequuntur modi sunt omnis. Cupiditate id sed temporibus in sed quas illum est.',
            keypoints: [
                'Voluptatibus cupiditate repellat fuga assumenda qui.',
                'Nemo rerum inventore quia quisquam quia.',
                'Nam perspiciatis nisi.',
                'Atque velit voluptatibus reiciendis.',
                'Ut officiis magnam harum.',
                'Molestias minus dicta quibusdam dignissimos ducimus.'
            ]
        }
    },
    {
        plan: 'Subscription Plan B',
        planKey: 'planB',
        planDescription: 'Exercitationem voluptas consequuntur repellendus eaut.',
        planDetails: {
            info: 'Non itaque voluptates. Et consequuntur modi sunt omnis. Cupiditate id sed temporibus in sed quas illum est.',
            keypoints: [
                'Voluptatibus cupiditate repellat fuga assumenda qui.',
                'Nemo rerum inventore quia quisquam quia.',
                'Nam perspiciatis nisi.',
                'Atque velit voluptatibus reiciendis.',
                'Ut officiis magnam harum.',
                'Molestias minus dicta quibusdam dignissimos ducimus.'
            ]
        }
    },
    {
        plan: 'Subscription Plan C',
        planKey: 'planC',
        planDescription: 'Exercitationem voluptas consequuntur repellendus eaut.',
        planDetails: {
            info: 'Non itaque voluptates. Et consequuntur modi sunt omnis. Cupiditate id sed temporibus in sed quas illum est.',
            keypoints: [
                'Voluptatibus cupiditate repellat fuga assumenda qui.',
                'Nemo rerum inventore quia quisquam quia.',
                'Nam perspiciatis nisi.',
                'Atque velit voluptatibus reiciendis.',
                'Ut officiis magnam harum.',
                'Molestias minus dicta quibusdam dignissimos ducimus.'
            ]
        }
    }
]

export const participationTypeOptions = [
    {
        value: 'ctro',
        label: 'Credit Transfer Receive Only'
    },
    {
        value: 'ctsr',
        label: 'Credit Transfer Send and Receive'
    },
    {
        value: 'rfp',
        label: 'Send/Receive with Receive RFP'
    },
    {
        value: 'liquidity',
        label: 'Liquidity Management'
    },
    {
        value: 'settlement',
        label: 'Settlement cases'
    }
];

export const simulatorTestData = [
    {
        id: '1',
        creditorAgentRTN: '0210-4007-8',
        accountId: '98562094',
        statusDesired: 'Account Settled - FEDNOW',
        actionFromSimulator: 'ACSC'
    },
    {
        id: '2',
        creditorAgentRTN: '0210-4007-8',
        accountId: '89268596',
        statusDesired: 'Customer Account Credited',
        actionFromSimulator: 'ACCC'
    },
    {
        id: '3',
        creditorAgentRTN: '0210-4007-8',
        accountId: '36208248',
        statusDesired: 'Accept without Posting - Block',
        actionFromSimulator: 'ACWP - BLCK'
    },
    {
        id: '4',
        creditorAgentRTN: '0210-4007-8',
        accountId: '92844927',
        statusDesired: 'Accept without Posting - Pending',
        actionFromSimulator: 'AWP - PNDG'
    },
    {
        id: '5',
        creditorAgentRTN: '0210-4007-8',
        accountId: '41304223',
        statusDesired: 'Accept without Posting - Rejected',
        actionFromSimulator: 'ACWP - RICT'
    },
    {
        id: '6',
        creditorAgentRTN: '0210-4007-8',
        accountId: '90381451',
        statusDesired: 'AWP - Account Credited',
        actionFromSimulator: 'ACWP - ACCC'
    },
    {
        id: '7',
        creditorAgentRTN: '0210-4007-8',
        accountId: '92170275',
        statusDesired: 'Reject - Invalid Creditor A/C',
        actionFromSimulator: 'RJCT -ACOB'
    },
    {
        id: '8',
        creditorAgentRTN: '0210-4007-8',
        accountId: '10254134',
        statusDesired: 'Account Settled - FEDNOW',
        actionFromSimulator: 'ACSC'
    },
    {
        id: '9',
        creditorAgentRTN: '0210-4007-8',
        accountId: '13747553',
        statusDesired: 'Reject - Account Blocked',
        actionFromSimulator: 'RICT - ACO6'
    },
    {
        id: '10',
        creditorAgentRTN: '0210-4007-8',
        accountId: '95545857',
        statusDesired: 'Reject - Account Closed',
        actionFromSimulator: 'RICT - ACO7'
    },
    {
        id: '11',
        creditorAgentRTN: '0210-4007-8',
        accountId: '25302172',
        statusDesired: 'Reject - Wrong Amount',
        actionFromSimulator: 'RICT - ACO9'
    },
    {
        id: '12',
        creditorAgentRTN: '0210-4007-8',
        accountId: '47256121',
        statusDesired: 'Reject - Missing or Incorrect',
        actionFromSimulator: 'RJCT - BE04'
    },
    {
        id: '13',
        creditorAgentRTN: '0210-4007-8',
        accountId: '55689263',
        statusDesired: 'Reject - Narrative',
        actionFromSimulator: 'RICT - NARR'
    },
    {
        id: '14',
        creditorAgentRTN: '0210-4007-8',
        accountId: '47256121',
        statusDesired: 'Reject - Regulatory Reason',
        actionFromSimulator: 'RJCT - BE04'
    },
    {
        id: '15',
        creditorAgentRTN: '0210-4007-8',
        accountId: '55689263',
        statusDesired: 'Reject - Duplicate',
        actionFromSimulator: 'RICT - NARR'
    }
]

const testPathValues = [
    {
        key: 'XPath - 1',
        value: ''
    },
    {
        key: 'XPath - 2',
        value: ''
    },
    {
        key: 'XPath - 3',
        value: ''
    },
    {
        key: 'XPath - 4',
        value: ''
    },
    {
        key: 'XPath - 5',
        value: ''
    },
    {
        key: 'XPath - 6',
        value: ''
    },
    {
        key: 'XPath - 7',
        value: ''
    },
    {
        key: 'XPath - 8',
        value: ''
    }
]

export const testCaseForParticipationType_columns = [
    {
        title: 'Discription',
        dataIndex: 'description',
        key: 'description',

    },
    {
        title: 'Trigger Message',
        dataIndex: 'triggerMessage',
        key: 'triggerMessage',
    },
    {
        title: 'Inbound Test Cases',
        dataIndex: 'inboundTestcases',
        key: 'inboundTestcases',
    },
    {
        title: 'Outbound Test Cases',
        dataIndex: 'outboundTestcases',
        key: 'outboundTestcases',
    },


]

export const simulatorTestData_columns = [
    {
        title: 'Message Flow',
        dataIndex: 'messageFlow',
        key: 'messageFlow',
    },
    {
        title: 'Last Updated',
        dataIndex: 'lastUpdateOn',
        key: 'lastUpdateOn',
    },
    {
        title: 'Updated By',
        dataIndex: 'lastUpdateByuserName',
        key: 'lastUpdateByuserName',
    },
    {
        title: 'Actions',
        dataIndex: 'reviewed',
        key: 'reviewed',

    },
]

export const settlementAccount_columns = [
    {
        title: 'Transaction ID / Message ID',
        dataIndex: "transactionId",
        key: "transactionId",
        width:"20%"
    },
    {
        title: 'Transaction Date',
        dataIndex: "transactionDate",
        key: "transactionDate",
        width:"13%"
    },
    {
        title: 'Description',
        dataIndex: "description",
        key: "description",
        width:"14%"
    },
    {
        title: 'RTNs',
        dataIndex: "routingNumber",
        key: "routingNumber",
    },
    {
        title: 'Updated by',
        dataIndex: "updatedBy",
        key: "updatedBy",
    },
    {
        title: 'Credit/ Debit',
        dataIndex: "debitCredit",
        key: "debitCredit",
    },
    {
        title: 'Amount',
        dataIndex: "amount",
        key: "amount",
        align: 'right',
    },
    {
        title: 'Available Balance',
        dataIndex: "availableBalance",
        key: "availableBalance",
        align: 'right',
    },

]

export const respondentBank_columns = [
    {
        title: 'Bank Name',
        dataIndex: "customerOrganizationName",
        key: "customerOrganizationName",
    },
    {
        title: 'Address',
        dataIndex: "address1",
        key: "address1",
    },
    {
        title: 'Account Status',
        dataIndex: "statusName",
        key: "statusName",
    },
    {
        title: 'RTNs',
        dataIndex: "RTNs",
        key: "RTNs",
    },
]

export const routingNumber_columns = [
    {
        title: 'Master RTN',
        dataIndex: "masterRtn",
        key: "masterRtn",
    },
    {
        title: 'Sub RTN',
        dataIndex: "subRtn",
        key: "subRtn",
    }, 
    {
        title: 'Respondent RTN',
        dataIndex: "respondentRtn",
        key: "respondentRtn",
    },
    {
        title: 'Bank Name',
        dataIndex: "bankName",
        key: "bankName",
    },
    {
        title: 'Bank Location',
        dataIndex: "bankLocation",
        key: "bankLocation",
    },
    {
        title: 'Is Active',
        dataIndex: "isActive",
        key: "isActive",
    },

]

export const retrievalRequest_columns = [
    Table.SELECTION_COLUMN,
    {
        title: 'Message ID',
        dataIndex: "messageId",
        key: "settlementAccountTransactionId",
        width:"24%"
    },
    {
        title: 'Message Type',
        dataIndex: "messageType",
        key: "messageType",
        width:"13%"
    },
    {
        title: 'Message Name',
        dataIndex: "messageName",
        key: "messageName",
        width:"14%"
    },
    {
        title: 'Flow Type',
        dataIndex: "flowType",
        key: "flowType",
        width:"11%"
       
    },
    {
        title: 'Routing Number',
        dataIndex: "rtnsInvolved",
        key: "rtnsInvolved",
        width:"16%"
    },
    {
        title: 'Created date & time',
        dataIndex: "createdDateTime",
        key: "createdDateTime",
    },
     
]



export const testData = [
    {
        id: '1',
        testCaseName: 'Test Cases - 1',
        testData: [...testPathValues]
    },
    {
        id: '2',
        testCaseName: 'Test Cases - 2',
        testData: [...testPathValues]
    },
    {
        id: '3',
        testCaseName: 'Test Cases - 3',
        testData: [...testPathValues]
    },
    {
        id: '4',
        testCaseName: 'Test Cases - 4',
        testData: [...testPathValues]
    },
    {
        id: '5',
        testCaseName: 'Test Cases - 5',
        testData: [...testPathValues]
    },
    {
        id: '6',
        testCaseName: 'Test Cases - 6',
        testData: [...testPathValues]
    },
    {
        id: '7',
        testCaseName: 'Test Cases - 7',
        testData: [...testPathValues]
    },
    {
        id: '8',
        testCaseName: 'Test Cases - 8',
        testData: [...testPathValues]
    }
];
export const standalone_columns = [
    Table.SELECTION_COLUMN,
    Table.EXPAND_COLUMN,
    {
        title: 'Test Case ID',
        dataIndex: 'customerTestScenarioName',
        key: 'customerTestScenarioName',
        sorter: true,
        // defaultSortOrder: 'ascend',
        width: '19%',
    },
    //     {
    //     title: 'Test Case Name',
    //     dataIndex: 'customerTestScenarioName',
    //     key: 'testCaseName',
    //   },
    {
        title: 'Description',
        dataIndex: 'customerTestcaseDescription',
        key: 'customerTestcaseDescription',
        width: '26.5%',
    },
    {
        title: 'Message Type',
        dataIndex: 'messageType',
        width: '17.3%',
        key: 'messageType',
    },
    {
        title: 'Direction',
        dataIndex: 'customerDirection',
        // width: '30%',
        key: 'direction',
        sorter: true,
    },
    {
        title: 'Test Data Status',
        dataIndex: 'reviewed',
        // width: '30%',
        key: 'reviewed',
    },
];
//for super admin due to width
export const standalone_SuperAdmin_columns = [
    Table.SELECTION_COLUMN,
    Table.EXPAND_COLUMN,
    {
        title: 'Test Case ID',
        dataIndex: 'customerTestScenarioName',
        key: 'customerTestScenarioName',
        sorter: true,
        // defaultSortOrder: 'ascend',
        width: '19%',
    },
    //     {
    //     title: 'Test Case Name',
    //     dataIndex: 'customerTestScenarioName',
    //     key: 'testCaseName',
    //   },
    {
        title: 'Description',
        dataIndex: 'customerTestcaseDescription',
        key: 'customerTestcaseDescription',
        width: '26%',
    },
    {
        title: 'Message Type',
        dataIndex: 'messageType',
        width: '14%',
        key: 'messageType',
    },
    {
        title: 'Direction',
        dataIndex: 'customerDirection',
        width: '11%',
        key: 'direction',
        sorter: true,
    },
    {
        title: 'Test Data Status',
        dataIndex: 'reviewed',
        width: '14.5%',
        key: 'reviewed',
    },
    {
        title: 'Active/ Inactive',
    }
];

export const testcase_columns = [
    Table.SELECTION_COLUMN,
    {
        title: 'Test Case ID',
        dataIndex: 'testCaseCode',
        key: 'testCaseCode',
        // sorter: true,
        // defaultSortOrder: 'ascend',
        width: '19%',
    },
    {
        title: 'Description',
        dataIndex: 'testCaseDescription',
        key: 'testCaseDescription',
        width: '26.5%',
        ellipsis: true,
    },
    {
        title: 'Message Type',
        dataIndex: 'triggerMessagetype',
        width: '17.3%',
        key: 'triggerMessagetype',
    },
    {
        title: 'Direction',
        dataIndex: 'inboundOrOutbound',
        // width: '30%',
        key: 'inboundOrOutbound',
        // sorter: true,
    },
    {
        title: 'Last Updated On',
        dataIndex: 'lastUpdatedOn',
        // width: '30%',
        key: 'lastUpdatedOn',
    },
    {
        title: 'View Test Data',
        dataIndex: 'reviewed',
        // width: '10%',
        key: 'reviewed',
    },
];
export const standalone_data = [
    {
        key: 1,
        name: 'SA_TC.PACS.008​',
        description: 'Customer Credit Transfer',
        message: 'PACS.008',
        direction: 'SEND',
        status: `Reviewed`,
        children: [

            {
                key: 11,
                name: 'SA_TC.PACS.008​',
                description: 'Customer Credit Transfer',
                message: 'PACS.008',
                direction: 'SEND',
                status: `Reviewed`,
                testcaseId: 'PCT_CCT_OB_001',
                testcaseDescription: `This test case allows the user to test the initiation of PACS008 from Debtor Agent /TPSP to FDN and receive a response PACS002 
              from DUT (acts as FDN/Creditor Agent) with Credit account Status (ACCC) - amount Credited - Happy Path`,
                prerequisite: [
                    { detail: 'PACS008 is generated with the data defined in Test data sheet ' },
                    { detail: 'valid PACS008 is available on the Debtor Agent outbound IBMMQ request queue ' },
                    { detail: 'IBM MQ connection details should be available ' },
                    { detail: 'DUT should be connected with FedNow IBM MQ before starting this testcase' }
                ],
                testcaseScenario: `Send Customer Credit Transfer (CCT) pacs.008 to simulator. Simulator acts as Creditor agent and Sends a PACS 002 withOW does settlement as well as generates a PACS002 with Status as ACSC. 

              This is the Happy Pth Scenario.`,
                entities: [
                    { entityName: 'DUT' },
                    { entityName: 'Simulator (which acts as FEDNOW/Creditor Agent)' }
                ],
                steps: [
                    {
                        stepName: 'Step 1',
                        instruction: 'Create a valid customer credit transfer message(pacs.008) with given test data.Send message to MQ outbound request queue',
                        expectedInstructionResult: 'Simulator receives the PACS008 in MQ message and processes',
                        expectedFinalResult: 'Simulator expected result'
                    }
                ],
                version: '1.0.1'
            },
            {
                key: 12,
                name: 'SA_TC.PACS.008​',
                description: 'Customer Credit Transfer',
                message: 'PACS.008',
                direction: 'SEND',
                status: `Reviewed`,
                //       children: [
                //         {
                //           key: 121,
                //           name: 'SA_TC.PACS.008​',
                //   description: 'Customer Credit Transfer',
                //   message: 'PACS.008',
                //   direction: 'SEND',
                //   status: `Reviewed`,
                //         },
                //       ],
            },
            {
                key: 13,
                name: 'SA_TC.PACS.008​',
                description: 'Customer Credit Transfer',
                message: 'PACS.008',
                direction: 'SEND',
                status: `Reviewed`,
                //       children: [
                //         {
                //           key: 131,
                //           name: 'SA_TC.PACS.008​',
                //   description: 'Customer Credit Transfer',
                //   message: 'PACS.008',
                //   direction: 'SEND',
                //   status: `Reviewed`,
                //           children: [
                //             {
                //               key: 1311,
                //               name: 'SA_TC.PACS.008​',
                //   description: 'Customer Credit Transfer',
                //   message: 'PACS.008',
                //   direction: 'SEND',
                //   status: `Reviewed`,
                //             },
                //             {
                //               key: 1312,
                //               name: 'SA_TC.PACS.008​',
                //   description: 'Customer Credit Transfer',
                //   message: 'PACS.008',
                //   direction: 'SEND',
                //   status: `Reviewed`,
                //             },
                //           ],
                //         },
                //       ],
            },
        ],
    },
    {
        key: 2,
        name: 'SA_TC.PACS.008​',
        description: 'Customer Credit Transfer',
        message: 'PACS.008',
        direction: 'SEND',
        status: `Reviewed`,
    },
];
export const users_columns = [
    {
        title: 'First Name',
        width: '20%',
        dataIndex: 'firstName',
        key: 'firstName',
        sorter: true,
    },
    {
        title: 'Last Name',
        width: '20%',
        sorter: true,
        dataIndex: 'lastName',
        key: 'lastName',
    },
    {
        title: 'Email',
        width: '35%',
        dataIndex: 'email',
        key: 'email',
    },
    {
        title: 'Mobile',
        width: '35%',
        dataIndex: 'mobile',
        key: 'mobile',
    },
    {
        title: 'Role',
        width: '30%',
        dataIndex: 'role',
        key: 'role',
    },
    {
        title: 'Status',
        width: '25%',
        dataIndex: 'status',
        key: 'status',
        render(text, record) {
            return {
                props: {
                    style: { opacity: text === "Active" ? 1 : 0.5 }
                },
                children: <div>{text}</div>
            };
        }

    },
    {
        title: 'Action',
        width: '20%',
        dataIndex: 'action',
        key: 'action',
    }
]
export const customer_columns = [
    {
        title: 'Customer Info',
        width: '30%',
        dataIndex: 'customerInfo',
        key: 'customerInfo'
    },
    {
        title: 'Organization Type / Payment Services',
        width: '35%',
        dataIndex: 'customerType',
        key: 'customerType',
    },
    // {
    //     title: 'Setup Info',
    //     width: '35%',
    //     dataIndex: 'setupInfo',
    //     key: 'setupInfo',
    // },
    // {
    //     title: 'Subscription plan',
    //     width: '25%',
    //     dataIndex: 'subscriptionPlanName',
    //     key: 'subscriptionPlanName',
    // },
    // {
    //     title: 'Validity Period ',
    //     width: '32%',
    //     dataIndex: 'validityStartDate',
    //     key: 'validityStartDate',
    // },
    {
        title: 'Account Status',
        width: '18%',
        dataIndex: 'statusName',
        key: 'statusName',
    },
    {
        title: 'Action',
        width: '15%',
        dataIndex: 'action',
        key: 'action',
    }
]

export const user_activityLogs_column = [
    {
        title: 'Date & Time',
        width: '15%',
        dataIndex: 'activityDateTime',
        key: 'activityDateTime'
    },
    {
        title: 'Activity by',
        width: '15%',
        dataIndex: 'userName',
        key: 'userName',
    },
    {
        title: 'Type',
        width: '18%',
        dataIndex: 'activityTypeName',
        key: 'activityTypeName',
    },
    {
        title: 'Description',
        width: '39%',
        dataIndex: 'activityDescription',
        key: 'activityDescription',
    },
    {
        title: 'Action',
        width: '6%',
        dataIndex: 'action',
        key: 'action',
    }
]

export const activityLog_view_columns = [
    {
        title: 'Data Element',
        width: '30%',
        dataIndex: 'fieldname',
        key: 'fieldname'
    },
    {
        title: 'Value',
        // width: '35%',
        dataIndex: 'old',
        key: 'old',
    }
]

export const testruns_columns = [
    {
        title: 'Test Run ID',
        dataIndex: 'testrunId',
        key: 'testrunId',
        // fixed: 'left',
        width: '20%'
    },
    {
        title: 'Test Case ID',

        dataIndex: 'testCaseCode',
        key: 'testCaseCode',
        // fixed: 'left',
        // width: 200
        // defaultSortOrder: 'ascend',
        width: '20%',
        sorter: true,
    },
    {
        title: 'Direction',
        dataIndex: 'direction',
        // width: '30%',
        key: 'direction',
        // width: 100
    },
    {
        title: 'Executed By',
        dataIndex: 'userName',
        // width: '30%',
        key: 'userName',
        // width: 150
    },
    {
        title: 'Date Executed',
        dataIndex: 'executedDate',
        // {compare: (a, b) => a.executedDate - b.executedDate},
        // width: '30%',
        key: 'executedDate',
        sorter: true,
        // render: (data, rec) => {
        //     // const custDt = convertToLocalTime(data);
        //     return (
        //         <div>{convertToLocalTime(data)}</div>
        //     )
        // },
        // width: 150
    },
    // {
    //     title: 'Execution Status',
    //     dataIndex: 'executionStatus',
    //     key: 'executionStatus',
    //     // width: 150
    // },
    // {
    //     title: 'Execution Result',
    //     dataIndex: 'executionTime',
    //     key: 'executionTime',
    //     // width: 150
    // },
    {
        title: 'Res Time',
        dataIndex: 'reponseTime',
        key: 'reponseTime',
        // width: 100
    },
    {
        title: 'Result',
        dataIndex: 'result',
        sorter: true,
        key: 'result',
        // width: 120
        // width: '12%',
    },
    {
        title: 'Logs',
        dataIndex: 'log',
        // width: '30%',
        key: 'Logs',
        width: '5%'
        // width: 100,
        // fixed: 'right'
    },
    {
        title: 'Test Data',
        dataIndex: 'TestData',
        // width: '30%',
        key: 'TestData',
        width: '5%'
        // width: 100,
        // fixed: 'right'
    },
];

export const testruns_batch_columns = [
    {
        title: 'File Name',
        dataIndex: 'inputFileName',
        key: 'inputFileName',
        // fixed: 'left',
        width: '15%'
    },
    {
        title: 'Executed By',
        dataIndex: 'testExecutedBy',
        width: '15%',
        key: 'testExecutedBy',
        // width: 150
    },
    {
        title: 'Time Executed',
        dataIndex: 'executedDateTime',
        key: 'executedDateTime',
        width: '18%'
    },
    {
        title: 'Time Uploaded',
        dataIndex: 'submittedDateTime',
        key: 'submittedDateTime',
        width: '18%'
    },
    {
        title: 'Res Time',
        dataIndex: 'responseTime',
        key: 'responseTime',
        width: '10%'
        // width: 100
    },
    {
        title: 'Result',
        dataIndex: 'testResult',
        key: 'testResult',
        width: '12%'
        // width: 120
        // width: '12%',
    },
    {
        title: 'Output File',
        dataIndex: 'outputFilePath',
        // width: '30%',
        key: 'outputFilePath',
        width: '10%'
        // width: 100,
        // fixed: 'right'
    },
   {
        title: 'Input File',
        dataIndex: 'inputFilePath',
        // width: '30%',
        key: 'inputFilePath',
        width: '10%'
        // width: 100,
        // fixed: 'right'
    },
];
export const executionSummary_columns = [

    Table.EXPAND_COLUMN,

    {
        title: "Batches",
        dataIndex: "batchName",
        width: "20%",
        // sorter: true,
        key: "batchName"
    },
    {
        title: "Executions",
        dataIndex: "executionCount",
        // width: "20%",
        // sorter: true,
        key: "executionCount",
    },
    {
        title: "Last Executed",
        dataIndex: "lastExecuted",
        key: "lastExecuted",
        // width: "8%"
    },
    {
        title: "Batch Creator",
        dataIndex: "batchCreator",
        // width: "9%",
        key: 'batchCreator'
    },
    {
        title: "Test Cases",
        dataIndex: "testcaseCount",
        // sorter: true,
        key: "testcaseCount",
        // width: "9%",

    },
    {
        title: "Executed",
        dataIndex: "executedtestcaseCount",
        key: "executedtestcaseCount",
        // width: '7%',

    },
    {
        title: "Passed",
        dataIndex: "pass",
        key: "pass",
    },
    {
        title: "Failed",
        dataIndex: "fail",
        // sorter: true,
        key: "fail",
        // width: '10%'
    },
    {
        title: "Timeout",
        dataIndex: "timeOut",
        key: "timeOut",
        // width: '5%'
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        // width: '5%'
    },
];



export const executionSummary_exapanded_columns = [
    {
        title: "",
        dataIndex: "",
        width: '4%',
    },
    {
        title: "Batches",
        dataIndex: "batchName",
        width: "18%",
        // sorter: true,
        key: "batchName"
    },
    {
        title: "",
        dataIndex: "",
        width: '10.5%',
        // sorter: true,
        key: "",
    },
    {
        title: "Last Executed",
        dataIndex: "lastExecuted",
        key: "lastExecuted",
        width: '8%'
    },
    {
        title: "",
        dataIndex: "",
        width: '9%',
        key: ''
    },
    {
        title: "Test Cases",
        dataIndex: "testcaseCount",
        // sorter: true,
        key: "testcaseCount",
        width: '8.5%',

    },
    {
        title: "Executed",
        dataIndex: "executedtestcaseCount",
        key: "executedtestcaseCount",
        width: '8%',

    },
    {
        title: "Passed",
        dataIndex: "pass",
        key: "pass",
        width: '9%',
    },
    {
        title: "Failed",
        dataIndex: "fail",
        // sorter: true,
        key: "fail",
        width: '8%',
    },
    {
        title: "Timeout",
        dataIndex: "timeOut",
        key: "timeOut",
        width: '8.5%',
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: '-10%'
    },
]
export const testruns_data = [
    {
        key: 1,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.008',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.008',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '3 sec',
        Result: 'In Progress',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 2,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.009',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.008',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '3 sec',
        Result: 'Failed',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 3,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.002',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.002',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '1 sec',
        Result: 'Success',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 4,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.004',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.004',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '1 sec',
        Result: 'Failed',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 5,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.008',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.008',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '3 sec',
        Result: 'Success',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 6,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.009',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.008',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '8 sec',
        Result: 'Failed',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 7,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.002',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.002',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '1 sec',
        Result: 'Success',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
    {
        key: 8,
        TestType: 'MF',
        TestCaseID: 'SA_TC.PACS.004',
        TestCaseName: 'Customer Credit Transfer',
        MessageType: 'PACS.004',
        direction: 'SEND',
        DateExecuted: '03/12/2023',
        ResTime: '3 sec',
        Result: 'Failed',
        Logs: 'doc',
        TestData: `Reviewed`,
    },
];
export const standalone_Testcase_columns = [
    Table.SELECTION_COLUMN,
    {
        title: '',
        dataIndex: '',
        key: '',
        width: 48,
    },
    {
        title: 'Test Case Name',
        dataIndex: 'testCaseName',
        width: '19%',
        key: 'testCaseName',
    },
    {
        title: 'Description',
        dataIndex: 'testCaseDescription',
        width: '26.5%',
        key: 'testCaseDescription',
        ellipsis: true,
    },
    {
        title: 'Message Type',
        dataIndex: 'triggerMessagetype',
        width: '17.3%',
        key: 'triggerMessagetype',
    },
    {
        title: 'Direction',
        dataIndex: 'inboundOrOutbound',
        // width: '20%',
        key: 'inboundOrOutbound',
    },
    {
        title: 'Test Data Status',
        width: "15%"
    },
];

//for super width changes

export const standalone_SuperAdmin_Testcase_columns = [
    Table.SELECTION_COLUMN,
    {
        title: '',
        dataIndex: '',
        key: '',
        width: 48,
    },
    {
        title: 'Test Case Name',
        dataIndex: 'testCaseName',
        width: '19%',
        key: 'testCaseName',
    },
    {
        title: 'Description',
        dataIndex: 'testCaseDescription',
        width: '26%',
        key: 'testCaseDescription',
        ellipsis: true,
    },
    {
        title: 'Message Type',
        dataIndex: 'triggerMessagetype',
        width: '14.5%',
        key: 'triggerMessagetype',
    },
    {
        title: 'Direction',
        dataIndex: 'inboundOrOutbound',
        width: '10%',
        key: 'inboundOrOutbound',
    },
    {
        title: 'Test Data Status',
        width: "15%"
    },
    {
        title: "Active/ Inactive",
    },
];

export const LogFileKeys = {
    // tc_test_run_log: {
    //     name: 'Test Execution Log', // Test execution log
    //     order: 0
    // },
    testRunId: {
        name: 'Test Run Id', // Test execution log
        order: 0
    },
    tcMessageLog: {
        name: 'Test Client message log', // Test Client message log
        order: 1
    },
    logId: {
        name: 'Test Client log Id', // Simulator message log (IN)
        order: 2
    },
    tcTestRunLog: {
        name: 'Test Client run log', // Simulator message log (OUT)
        order: 3
    },
    // sim_console_log: {
    //     name: 'Simulator console log', // Simulator console log
    //     order: 4
    // },
    pgw_in_message_log: {
        name: "Payment Gateway (inbound msg)",
        order: 5
    },
    pgw_out_message_log: {
        name: "Payment Gateway (outbound msg)",
        order: 6
    },
    pgw_console_log: {
        name: "Payment Gateway console log",
        order: 7
    },
}

export const AuditLogs = [
    {
        shortName: 'PGW',
        label: 'Payment Gateway',
        key: 'pgw'
    },
    {
        shortName: 'FIS',
        label: 'Financial Institute Service',
        key: 'fis'
    },
    {
        shortName: 'FNS',
        label: 'FedNow Service',
        key: 'fns'
    }
]
export const messageXmllist_columns = [
    Table.SELECTION_COLUMN,
    Table.EXPAND_COLUMN,

    {
        title: 'XML File Name',
        dataIndex: 'fileName',
        key: 'fileName',
        sorter: true,
        width: '26.5%',
    },
    {
        title: 'Message Type',
        dataIndex: 'messageType',
        width: '17.3%',
        key: 'messageType',
    },
    {
        title: 'Direction',
        dataIndex: 'direction',
        // width: '30%',
        key: 'direction',
    },
    {
        title: 'Created Date',
        dataIndex: 'createdDate',
        key: 'createdDate',
        // width: '19%',
    },
    {
        title: 'Status',
        dataIndex: 'xmlStatus',
        // width: '30%',
        key: 'xmlStatus',
    },

    {
        title: 'Action',
        dataIndex: 'action',
        // width: '30%',
        key: 'action',
    },
];

export const testbatch_files_columns = [
    {
        title: "",
        dataIndex: "",
        width: 15,
    },
    Table.SELECTION_COLUMN,
    Table.EXPAND_COLUMN,
    {
        title: "Batch/Test Run Id",
        dataIndex: "customerBatchRunId",
        width: "20%",
        sorter: true,
        key: "customerBatchRunId"
    },
    {
        title: "Batch/Test Case Name",
        dataIndex: "testRunBatchName",
        width: "20%",
        sorter: true,
        key: "testRunBatchName",
    },
    {
        title: "Direction",
        dataIndex: "batchDirection",
        key: "batchDirection",
        width: "8%"
    },
    {
        title: "Executed By",
        dataIndex: "executedBy",
        width: "9%",
        key: 'executedBy'
    },
    {
        title: "Date Executed",
        dataIndex: "batchSubmittedDateTime",
        sorter: true,
        key: "batchSubmittedDateTime",
        width: "9%",
        render: (data, rec) => {
            const custDt = data ? convertToLocalTime(data) : '';
            return (
                <div>{custDt}</div>
            )
        },
    },
    {
        title: "Res.Time",
        dataIndex: "responseTime",
        key: "resTime",
        width: '7%',
        render: () => ''
    },
    {
        title: "Result",
        dataIndex: "statusCheck",
        sorter: true,
        key: "result",
        width: '10%'
    },
    {
        title: "Logs",
        dataIndex: "customerBatchRunId",
        key: "logs",
        width: '5%'
    },
    {
        title: "Test Data",
        dataIndex: "testData",
        key: "testData",
        width: '5%'
    },
]

export const testbatch_files_columns_expand = [
    Table.EXPAND_COLUMN,
    {
        title: '',
        dataIndex: '',
        key: '',
        width: 30,
    },
    {
        title: "Batch/Test Run Id",
        dataIndex: "customerTestRunId",
        width: '20%'
    },
    {
        title: "Batch/Test Case Name",
        dataIndex: "customerTestCaseCode",
        width: '20%'
    },
    {
        title: "Direction",
        dataIndex: "inboundOrOutbound",
        width: "8%"

    },
    {
        title: "Executed By",
        dataIndex: "executedby",
        width: "9%"

    },
    {
        title: "Date Executed",
        dataIndex: "executedDateTime",
        width: "9%",
        render: (data, rec) => {
            const custDt = data ? convertToLocalTime(data) : '';
            return (
                <div>{custDt}</div>
            )
        },
    },
    {
        title: "Res.Time",
        dataIndex: "responseTime",
        width: "7%"
    },
    {
        title: "Result",
        dataIndex: "result",
        width: "10%"
    },
    {
        title: "Logs",
        dataIndex: "log",
        width: '5%'

    },
    {
        title: "Test Data",
        dataIndex: "testData",
        width: '5%'
    },
]

export const testbatch_data = [
    {
        key: 1,
        testRunId: "PA898901",
        batchFileName: "Value-Message Customer Credit Transfer",
        direction: "",
        lastExecuted: "03/12/2023",
        executedBy: "swathi",
        executionResult: "SEND",
        createdDate: "03/12/2023",
        result: "In Progress",
        testRunId: 10,
        testData: "",
        // children: [
        //     {
        //         key: 11,
        //         testRunId: "PA898902",
        //         batchFileName: "SA_TC.PACS.008.1 Customer Credit Transfer PACS.008",
        //         direction: "",
        //         dateExecuted: "",
        //         executionStatus: "SEND",
        //         executionResult: "SEND",
        //         resTime: "",
        //         result: "In Progress",
        //         logs: "",
        //         testData: "",
        //     },
        //     {
        //         key: 12,
        //         testRunId: "PA898902",
        //         batchFileName: "SA_TC.PACS.008.1 Customer Credit Transfer PACS.008",
        //         direction: "",
        //         dateExecuted: "",
        //         executionStatus: "SEND",
        //         executionResult: "SEND",
        //         resTime: "5sec",
        //         result: "Success",
        //         logs: "",
        //         testData: "",
        //     },
        // ]
    },

]

export const testbatch_data_expand = [
    {
        testRunId: "PA898902",
        batchFileName: "SA_TC.PACS.008.1 Customer Credit Transfer PACS.008",
        direction: "",
        dateExecuted: "",
        executionStatus: "SEND",
        executionResult: "SEND",
        resTime: "",
        result: "In Progress",
        logs: "",
        testData: "",
    },
    {
        testRunId: "PA898902",
        batchFileName: "SA_TC.PACS.008.1 Customer Credit Transfer PACS.008",
        direction: "",
        dateExecuted: "",
        executionStatus: "SEND",
        executionResult: "SEND",
        resTime: "5sec",
        result: "Success",
        logs: "",
        testData: "",
    },
]

export const Roles = {
    ADMIN: {
        name: 'Admin',
        id: 1
    },
    SUPER_ADMIN: {
        name: 'Super Admin',
        id: 3
    },
    TESER: {
        name: 'Super Admin',
        id: 2
    }
}


const messageLog = {
    "origMessageId": "20230515021040078jGEuvmkFm25336925",
    "noOfMessages": 6,
    "error": false,
    "errorMsg": null,
    "listOfMessages": [
        {
            "messageId": "20230515021040078jGEuvmkFm25336925",
            "messageStatus": "IB_REQ_FIS",
            "messageType": "Inbound",
            "messageStatusDescription": "Inbound request from Financial Institution",
            "message": "{\n  \"dbtr_bldg\": \"Max Towers\",\n  \"CreDt\": \"2023-05-15T19:17:10\",\n  \"cdtr_ctryofres\": \"US\",\n  \"dbtracct_prxy_id\": \"19765836524\",\n  \"initgpty_prvtid_id\": \"31234567\",\n  \"ultmtcdtr_name\": \"Sarah Jane\",\n  \"ultmtcdtr_orgid_oth_id\": \"763455\",\n  \"createdDateTime\": \"2023-05-15T19:17:10\",\n  \"dbtracct_prxy_tp_cd\": \"TELE\",\n  \"ultmtdbtr_ctryofres\": \"US\",\n  \"cdtr_prvtid_oth_id\": \"31234567\",\n  \"instructed_agent\": \"021040079\",\n  \"ultmtdbtr_prvtid\": \"RemoveTag\",\n  \"MsgDefIdr\": \"pacs.008.001.08\",\n  \"dbtr_state\": \"NY\",\n  \"rmtinf\": \"NoAction\",\n  \"cdtracct_tp_cd\": \"CASH\",\n  \"ultmtcdtr_orgid\": \"NoAction\",\n  \"rltdrmtinf\": \"NoAction\",\n  \"cdtracct_prxy_tp_cd\": \"TELE\",\n  \"initgprty_twnnm\": \"New York\",\n  \"instructing_agent_code\": \"USABA\",\n  \"transaction_id\": \"vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr\",\n  \"rltdrmtinf_pstladr_ctr\": \"AZ\",\n  \"receiver\": \"021150706\",\n  \"ultmtdbtr_postcode\": \"AB6654F\",\n  \"dbtr_prvtid_oth_id\": \"31234568\",\n  \"ultmtdbtr_prvtid_id\": \"31234568\",\n  \"ultmtcdtr_twnnm\": \"New York\",\n  \"ultmtcdtr_prvtid\": \"RemoveTag\",\n  \"cdtr_adrline\": \"3rd Dream Road\",\n  \"initgprty_orgid\": \"NoAction\",\n  \"dbtr_orgid_oth\": \"NoAction\",\n  \"settlement_Amount\": \"12.05\",\n  \"ultmtcdtr_bldg\": \"Dream Aura\",\n  \"ultmtcdtr_ctryofres\": \"US\",\n  \"sender\": \"021040078\",\n  \"initgpty\": \"NoAction\",\n  \"remittanceDoc\": \"CINV\",\n  \"purp\": \"NoAction\",\n  \"uetr\": \"462c23a1-bff1-48e2-922b-86b96f88e89d\",\n  \"dbtr_orgid_oth_id\": \"31234567\",\n  \"rltdrmtinf_pstladr_adrline\": \"3rd Dream Road\",\n  \"cdtr_orgid\": \"NoAction\",\n  \"dbtragt_bicfi\": \"BE20USS8\",\n  \"localinstrument_cd\": \"NoAction\",\n  \"creditoragent\": \"021040079\",\n  \"rltdrmtinf_pstladr_name\": \"Bella Jean\",\n  \"NbOfTxs\": \"1\",\n  \"initgpty_pst_name\": \"Sarah Jane\",\n  \"ultmtdbtr_twnnm\": \"New York\",\n  \"remittancedate\": \"2023-02-06\",\n  \"dbtr_name\": \"John Wick\",\n  \"initgpty_prvtid\": \"RemoveTag\",\n  \"initgprty_state\": \"NY\",\n  \"chargebearer\": \"SLEV\",\n  \"rltdrmtinf_rmtid\": \"Remittance 432\",\n  \"cdtr_bldg\": \"Rose Garden\",\n  \"debtoragent\": \"021040078\",\n  \"instdagt\": \"NoAction\",\n  \"ultmtcdtr_prvtid_oth_id\": \"31234569\",\n  \"dbtr_prvtid_oth\": \"NoAction\",\n  \"message_id\": \"20230515021040078jGEuvmkFm25336925\",\n  \"debtor_acc\": \"11111000001\",\n  \"rmtinf_strd\": \"NoAction\",\n  \"ultmtdbtr_pst_name\": \"Sarah Jane\",\n  \"initgprty_postcode\": \"A654HG\",\n  \"ultmtdbtr_bldg\": \"Max Towers\",\n  \"initgpty_orgid_oth_id\": \"763456\",\n  \"initgpty_ctryofres\": \"US\",\n  \"dbtragt_cd\": \"USABA\",\n  \"purpose_cd\": \"ACCT\",\n  \"cdtragt_bicfi\": \"FA16USS8\",\n  \"ultmtcdtr_orgid_oth\": \"NoAction\",\n  \"ultmtdbtr_adrline\": \"3rd Dream Road\",\n  \"cdtragt_cd\": \"USABA\",\n  \"instructed_agent_code\": \"USABA\",\n  \"ultmtdbtr\": \"NoAction\",\n  \"initgprty_name\": \"Sarah Jane\",\n  \"cdtr_prvtid\": \"RemoveTag\",\n  \"initgpty_prvtid_oth\": \"NoAction\",\n  \"cdtracct_prxy_id\": \"18764562487\",\n  \"remittanceId\": \"INV-09123\",\n  \"instgagt\": \"NoAction\",\n  \"settlement_method\": \"CLRG\",\n  \"localinstrument_prtry\": \"FDNA\",\n  \"service_level_cd\": \"SEPA\",\n  \"rltdrmtinf_mtd\": \"FAXI\",\n  \"dbtragt_name\": \"Micheal Ryan\",\n  \"cdtr_name\": \"Max Smith\",\n  \"initgpty_adrline\": \"3rd Dream Road\",\n  \"settlement_date\": \"2023-05-15\",\n  \"dbtr_orgid\": \"NoAction\",\n  \"cdtr_state\": \"AZ\",\n  \"ultmtdbtr_state\": \"NY\",\n  \"creditoracc\": \"61111000001\",\n  \"instructing_agent\": \"021040078\",\n  \"ultmtcdtr_prvtid_id\": \"31234568\",\n  \"cdtracct_id_iban\": \"RemoveTag\",\n  \"initgprty_bldg\": \"Dream Aura\",\n  \"cdtr_prvtid_oth\": \"NoAction\",\n  \"dbtr_prvtid\": \"RemoveTag\",\n  \"ultmtdbtr_orgid_oth_id\": \"31234568\",\n  \"cdtr_orgid_oth\": \"NoAction\",\n  \"service_level_prtry\": \"RemoveTag\",\n  \"ultmtcdtr_adrline\": \"3rd Dream Road\",\n  \"ultmtdbtr_orgid_oth\": \"NoAction\",\n  \"dbtr_ctryofres\": \"US\",\n  \"dbtragt_adrline\": \"3rd Dream Road\",\n  \"ultmtcdtr_postcode\": \"A654HG\",\n  \"ultmtcdtr_state\": \"NY\",\n  \"ultmtdbtr_name\": \"John Wick\",\n  \"clearing_system\": \"FDN\",\n  \"initgpty_orgid_oth\": \"RemoveTag\",\n  \"cdtr_orgid_oth_id\": \"31234567\",\n  \"cdtr_twnnm\": \"Riverside\",\n  \"dbtragt\": \"NoAction\",\n  \"dbtracct_tp_cd\": \"CASH\",\n  \"amount_currency\": \"USD\",\n  \"purpose_code\": \"CONS\",\n  \"cdtr_postcode\": \"GF5437Y\",\n  \"dbtr_postcode\": \"AB6654F\",\n  \"endtoend_id\": \"nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f\",\n  \"rmtinf_ustrd\": \"RemoveTag\",\n  \"BizMsgIdr\": \"20230515021040078FGnVZEIcV40885693\",\n  \"ultmtcdtr\": \"NoAction\",\n  \"dbtr_twnnm\": \"New York\",\n  \"dbtracct_id_iban\": \"RemoveTag\",\n  \"dbtr_adrline\": \"3rd Dream Road\",\n  \"ultmtdbtr_orgid\": \"NoAction\",\n  \"ultmtcdtr_prvtid_oth\": \"NoAction\",\n  \"instruction_id\": \"eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq\"\n}",
            "timeStamp": "2023-05-15T19:17:10.869+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": null,
            "creditorAccID": null,
            "status": null
        },
        {
            "messageId": "20230515021040078jGEuvmkFm25336925",
            "messageStatus": "IB_REQ_FIS_TO_FNS",
            "messageType": "pacs.008.001.08",
            "messageStatusDescription": "Inbound request from Financial institution to Fednow Simulator",
            "message": "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?><p:Document xmlns:p=\"urn:iso:std:iso:20022:tech:xsd:pacs.008.001.08\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:schemaLocation=\"urn:iso:std:iso:20022:tech:xsd:pacs.008.001.08 CustomerCreditTransfer_pacs_008.xsd \">\n  <h:AppHdr xmlns:h=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02\" xsi:schemaLocation=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02 BusinessApplicationHeader_head_001_001_02_20210617.xsd\">\n\t\t<h:Fr>\n\t\t\t<h:FIId>\n\t\t\t\t<h:FinInstnId>\n\t\t\t\t\t<h:ClrSysMmbId>\n\t\t\t\t\t\t<h:MmbId>021040078</h:MmbId>\n\t\t\t\t\t</h:ClrSysMmbId>\n\t\t\t\t</h:FinInstnId>\n\t\t\t</h:FIId>\n\t\t</h:Fr>\n\t\t<h:To>\n\t\t\t<h:FIId>\n\t\t\t\t<h:FinInstnId>\n\t\t\t\t\t<h:ClrSysMmbId>\n\t\t\t\t\t\t<h:MmbId>021150706</h:MmbId>\n\t\t\t\t\t</h:ClrSysMmbId>\n\t\t\t\t</h:FinInstnId>\n\t\t\t</h:FIId>\n\t\t</h:To>\n\t\t<h:BizMsgIdr>20230515021040078FGnVZEIcV40885693</h:BizMsgIdr>\n\t\t<h:MsgDefIdr>pacs.008.001.08</h:MsgDefIdr>\n\t\t<h:MktPrctc>\n\t\t\t<h:Regy>www2.swift.com/mystandards/#/group/Federal_Reserve_Financial_Services/FedNow_Service</h:Regy>\n\t\t\t<h:Id>frb.fednow.01</h:Id>\n\t\t</h:MktPrctc>\n\t\t<h:CreDt>2023-05-15T19:17:10</h:CreDt>\n\t\t\n\t</h:AppHdr>\n  <p:FIToFICstmrCdtTrf>\n    <p:GrpHdr>\n      <p:MsgId>20230515021040078jGEuvmkFm25336925</p:MsgId>\n      <p:CreDtTm>2023-05-15T19:17:10</p:CreDtTm>\n      <p:NbOfTxs>1</p:NbOfTxs>\n      <p:SttlmInf>\n        <p:SttlmMtd>CLRG</p:SttlmMtd>\n        <p:ClrSys>\n          <p:Cd>FDN</p:Cd>\n        </p:ClrSys>\n      </p:SttlmInf>\n    </p:GrpHdr>\n    <p:CdtTrfTxInf>\n      <p:PmtId>\n        <p:InstrId>eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq</p:InstrId>\n        <p:EndToEndId>nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f</p:EndToEndId>\n        <p:TxId>vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr</p:TxId>\n        <p:UETR>462c23a1-bff1-48e2-922b-86b96f88e89d</p:UETR>\n      </p:PmtId>\n      <p:PmtTpInf>\n        <p:SvcLvl>\n          <p:Cd>SEPA</p:Cd>\n\t\t  \n        </p:SvcLvl>\n        <p:LclInstrm>\n          <p:Prtry>FDNA</p:Prtry>\n        </p:LclInstrm>\n        <p:CtgyPurp>\n          <p:Prtry>CONS</p:Prtry>\n        </p:CtgyPurp>\n      </p:PmtTpInf>\n      <p:IntrBkSttlmAmt Ccy=\"USD\">12.05</p:IntrBkSttlmAmt>\n      <p:IntrBkSttlmDt>2023-05-15</p:IntrBkSttlmDt>\n      <p:ChrgBr>SLEV</p:ChrgBr>\n      <p:InstgAgt>\n        <p:FinInstnId>\n          <p:ClrSysMmbId>\n            <p:ClrSysId>\n              <p:Cd>USABA</p:Cd>\n            </p:ClrSysId>\n            <p:MmbId>021040078</p:MmbId>\n          </p:ClrSysMmbId>\n        </p:FinInstnId>\n      </p:InstgAgt>\n      <p:InstdAgt>\n        <p:FinInstnId>\n          <p:ClrSysMmbId>\n            <p:ClrSysId>\n              <p:Cd>USABA</p:Cd>\n            </p:ClrSysId>\n            <p:MmbId>021040079</p:MmbId>\n          </p:ClrSysMmbId>\n        </p:FinInstnId>\n      </p:InstdAgt>\n      <p:UltmtDbtr>\n        <p:Nm>John Wick</p:Nm>\n        <p:PstlAdr>\n          <p:Dept>Finance</p:Dept>\n          <p:SubDept>Accounts Payable</p:SubDept>\n          <p:StrtNm>9th Avenue</p:StrtNm>\n          <p:BldgNb>12</p:BldgNb>\n          <p:BldgNm>Max Towers</p:BldgNm>\n          <p:Flr>3rd Floor</p:Flr>\n          <p:PstBx>1180</p:PstBx>\n          <p:Room>257</p:Room>\n          <p:PstCd>AB6654F</p:PstCd>\n          <p:TwnNm>New York</p:TwnNm>\n          <p:TwnLctnNm>Alexzander city</p:TwnLctnNm>\n          <p:DstrctNm>Alabama</p:DstrctNm>\n          <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n          <p:Ctry>US</p:Ctry>\n          <p:AdrLine>3rd Dream Road</p:AdrLine>\n        </p:PstlAdr>\n        <p:Id>\n          <p:OrgId>\n            <p:AnyBIC>AS12CDQ1B56</p:AnyBIC>\n            <p:LEI>1AC4D5E1G6I8J9H0H034</p:LEI>\n            <p:Othr>\n              <p:Id>31234568</p:Id>\n              <p:SchmeNm>\n                <p:Cd>008</p:Cd>\n              </p:SchmeNm>\n              <p:Issr>PAC008</p:Issr>\n            </p:Othr>\n          </p:OrgId>\n          \n        </p:Id>\n        <p:CtryOfRes>US</p:CtryOfRes>\n      </p:UltmtDbtr>\n      <p:InitgPty>\n        <p:Nm>Sarah Jane</p:Nm>\n        <p:PstlAdr>\n          <p:Dept>Finance</p:Dept>\n          <p:SubDept>Accounts Payable</p:SubDept>\n          <p:StrtNm>Dream Road</p:StrtNm>\n          <p:BldgNb>141</p:BldgNb>\n          <p:BldgNm>Dream Aura</p:BldgNm>\n          <p:Flr>2nd floor</p:Flr>\n          <p:PstBx>450</p:PstBx>\n          <p:Room>204</p:Room>\n          <p:PstCd>A654HG</p:PstCd>\n          <p:TwnNm>New York</p:TwnNm>\n          <p:TwnLctnNm>Alaskha</p:TwnLctnNm>\n          <p:DstrctNm>Texas</p:DstrctNm>\n          <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n          <p:Ctry>US</p:Ctry>\n          <p:AdrLine>3rd Dream Road</p:AdrLine>\n        </p:PstlAdr>\n        <p:Id>\n          <p:OrgId>\n            <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n            <p:LEI>1ZC4D5E1J6I8J9H1W034</p:LEI>\n            \n          </p:OrgId>\n          \n        </p:Id>\n        <p:CtryOfRes>US</p:CtryOfRes>\n      </p:InitgPty>\n      <p:Dbtr>\n        <p:Nm>John Wick</p:Nm>\n        <p:PstlAdr>\n          <p:Dept>Finance</p:Dept>\n          <p:SubDept>Accounts Payable</p:SubDept>\n          <p:StrtNm>Oxford Road</p:StrtNm>\n          <p:BldgNb>Unit 143</p:BldgNb>\n          <p:BldgNm>Max Towers</p:BldgNm>\n          <p:Flr>2nd Floor</p:Flr>\n          <p:PstBx>19067</p:PstBx>\n          <p:Room>345</p:Room>\n          <p:PstCd>AB6654F</p:PstCd>\n          <p:TwnNm>New York</p:TwnNm>\n          <p:TwnLctnNm>ARIZONA</p:TwnLctnNm>\n          <p:DstrctNm>ARIZONA</p:DstrctNm>\n          <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n          <p:Ctry>US</p:Ctry>\n          <p:AdrLine>3rd Dream Road</p:AdrLine>\n        </p:PstlAdr>\n        <p:Id>\n          <p:OrgId>\n            <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n            <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n            <p:Othr>\n              <p:Id>31234567</p:Id>\n              <p:SchmeNm>\n                <p:Cd>008</p:Cd>\n              </p:SchmeNm>\n              <p:Issr>Pac008</p:Issr>\n            </p:Othr>\n          </p:OrgId>\n          \n        </p:Id>\n        <p:CtryOfRes>US</p:CtryOfRes>\n      </p:Dbtr>\n      <p:DbtrAcct>\n\t\t<p:Id>\n<!--\t\t\t<p:IBAN>78979</p:IBAN>-->\n\t\t\t<p:Othr>\n\t\t\t\t<p:Id>11111000001</p:Id>\n\t\t\t</p:Othr>\n\t\t</p:Id>\n        <p:Tp>\n          <p:Cd>CASH</p:Cd>\n        </p:Tp>\n        <p:Prxy>\n          <p:Tp>\n            <p:Cd>TELE</p:Cd>\n          </p:Tp>\n          <p:Id>19765836524</p:Id>\n        </p:Prxy>\n      </p:DbtrAcct>\n      <p:DbtrAgt>\n        <p:FinInstnId>\n          <p:BICFI>BE20USS8</p:BICFI>\n          <p:ClrSysMmbId>\n            <p:ClrSysId>\n              <p:Cd>USABA</p:Cd>\n            </p:ClrSysId>\n            <p:MmbId>021040078</p:MmbId>\n          </p:ClrSysMmbId>\n          <p:LEI>1AS2DF34GH45M9L08E09</p:LEI>\n          <p:Nm>Micheal Ryan</p:Nm>\n          <p:PstlAdr>\n            <p:Dept>Finance</p:Dept>\n            <p:SubDept>Accounts Payable</p:SubDept>\n            <p:StrtNm>Avenue of the Fountains</p:StrtNm>\n            <p:BldgNb>Suite D110</p:BldgNb>\n            <p:BldgNm>Keepers</p:BldgNm>\n            <p:Flr>6th Floor</p:Flr>\n            <p:PstBx>1</p:PstBx>\n            <p:Room>567</p:Room>\n            <p:PstCd>85268</p:PstCd>\n            <p:TwnNm>Fountain Hills</p:TwnNm>\n            <p:TwnLctnNm>Phenix City</p:TwnLctnNm>\n            <p:DstrctNm>Alabama</p:DstrctNm>\n            <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n            <p:Ctry>US</p:Ctry>\n            <p:AdrLine>3rd Dream Road</p:AdrLine>\n          </p:PstlAdr>\n        </p:FinInstnId>\n      </p:DbtrAgt>\n      <p:CdtrAgt>\n        <p:FinInstnId>\n          <p:BICFI>FA16USS8</p:BICFI>\n          <p:ClrSysMmbId>\n            <p:ClrSysId>\n              <p:Cd>USABA</p:Cd>\n            </p:ClrSysId>\n            <p:MmbId>021040079</p:MmbId>\n          </p:ClrSysMmbId>\n          <p:LEI>1AS2DF34GH45M9L08E09</p:LEI>\n          <p:Nm>Neil Mathew</p:Nm>\n          <p:PstlAdr>\n            <p:Dept>Finance</p:Dept>\n            <p:SubDept>Accounts Payable</p:SubDept>\n            <p:StrtNm>Dream Road</p:StrtNm>\n            <p:BldgNb>Unit 81</p:BldgNb>\n            <p:BldgNm>New View</p:BldgNm>\n            <p:Flr>1st Floor</p:Flr>\n            <p:PstBx>1</p:PstBx>\n            <p:Room>56</p:Room>\n            <p:PstCd>10001</p:PstCd>\n            <p:TwnNm>New York</p:TwnNm>\n            <p:TwnLctnNm>ALAMEDA</p:TwnLctnNm>\n            <p:DstrctNm>California</p:DstrctNm>\n            <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n            <p:Ctry>US</p:Ctry>\n            <p:AdrLine>25 Dream Road</p:AdrLine>\n          </p:PstlAdr>\n        </p:FinInstnId>\n      </p:CdtrAgt>\n      <p:Cdtr>\n        <p:Nm>Max Smith</p:Nm>\n        <p:PstlAdr>\n          <p:Dept>Finance</p:Dept>\n          <p:SubDept>Accounts Payable</p:SubDept>\n          <p:StrtNm>Ocean Street</p:StrtNm>\n          <p:BldgNb>UNit 6</p:BldgNb>\n          <p:BldgNm>Rose Garden</p:BldgNm>\n          <p:Flr>3rd Floor</p:Flr>\n          <p:PstBx>1</p:PstBx>\n          <p:Room>456</p:Room>\n          <p:PstCd>GF5437Y</p:PstCd>\n          <p:TwnNm>Riverside</p:TwnNm>\n          <p:TwnLctnNm>D Land</p:TwnLctnNm>\n          <p:DstrctNm>Florida</p:DstrctNm>\n          <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n          <p:Ctry>US</p:Ctry>\n          <p:AdrLine>3rd Dream Road</p:AdrLine>\n        </p:PstlAdr>\n        <p:Id>\n          <p:OrgId>\n            <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n            <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n            <p:Othr>\n              <p:Id>31234567</p:Id>\n              <p:SchmeNm>\n                <p:Cd>008</p:Cd>\n              </p:SchmeNm>\n              <p:Issr>pac008</p:Issr>\n            </p:Othr>\n          </p:OrgId>\n\t\t  \n        </p:Id>\n        <p:CtryOfRes>US</p:CtryOfRes>\n      </p:Cdtr>\n      <p:CdtrAcct>\n<!--\t\t<p:IBAN>78979</p:IBAN>-->\n\t\t<p:Id>\n\t\t\t<p:Othr>\n\t\t\t\t<p:Id>61111000001</p:Id>\n\t\t\t</p:Othr>\n\t\t</p:Id>\n        <p:Tp>\n          <p:Cd>CASH</p:Cd>\n        </p:Tp>\n        <p:Prxy>\n          <p:Tp>\n            <p:Cd>TELE</p:Cd>\n          </p:Tp>\n          <p:Id>18764562487</p:Id>\n        </p:Prxy>\n      </p:CdtrAcct>\n      <p:UltmtCdtr>\n        <p:Nm>Sarah Jane</p:Nm>\n        <p:PstlAdr>\n          <p:Dept>Finance</p:Dept>\n          <p:SubDept>Accounts Payable</p:SubDept>\n          <p:StrtNm>Dream Road</p:StrtNm>\n          <p:BldgNb>Unit 81</p:BldgNb>\n          <p:BldgNm>Dream Aura</p:BldgNm>\n          <p:Flr>2nd Floor</p:Flr>\n          <p:PstBx>1</p:PstBx>\n          <p:Room>45</p:Room>\n          <p:PstCd>A654HG</p:PstCd>\n          <p:TwnNm>New York</p:TwnNm>\n          <p:TwnLctnNm>Alameda</p:TwnLctnNm>\n          <p:DstrctNm>California</p:DstrctNm>\n          <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n          <p:Ctry>US</p:Ctry>\n          <p:AdrLine>3rd Dream Road</p:AdrLine>\n        </p:PstlAdr>\n        <p:Id>\n          <p:OrgId>\n            <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n            <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n            <p:Othr>\n              <p:Id>763455</p:Id>\n              <p:SchmeNm>\n                <p:Cd>008</p:Cd>\n              </p:SchmeNm>\n              <p:Issr>pac008</p:Issr>\n            </p:Othr>\n          </p:OrgId>\n          \n        </p:Id>\n        <p:CtryOfRes>US</p:CtryOfRes>\n      </p:UltmtCdtr>\n      <p:Purp>\n        <p:Cd>ACCT</p:Cd>\n      </p:Purp>\n      <p:RltdRmtInf>\n        <p:RmtId>Remittance 432</p:RmtId>\n        <p:RmtLctnDtls>\n          <p:Mtd>FAXI</p:Mtd>\n          <p:ElctrncAdr>Marygrace_123</p:ElctrncAdr>\n          <p:PstlAdr>\n            <p:Nm>Bella Jean</p:Nm>\n            <p:Adr>\n              <p:Dept>Finance</p:Dept>\n              <p:SubDept>Accounts Payable</p:SubDept>\n              <p:StrtNm>RailRoad Ave</p:StrtNm>\n              <p:BldgNb>unit 81</p:BldgNb>\n              <p:BldgNm>Happy Villege</p:BldgNm>\n              <p:Flr>1st Floor</p:Flr>\n              <p:PstBx>2</p:PstBx>\n              <p:Room>34</p:Room>\n              <p:PstCd>14561</p:PstCd>\n              <p:TwnNm>palm Springs</p:TwnNm>\n              <p:TwnLctnNm>Athens</p:TwnLctnNm>\n              <p:DstrctNm>Alabama</p:DstrctNm>\n              <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n              <p:Ctry>US</p:Ctry>\n              <p:AdrLine>1 RailRoad Ave</p:AdrLine>\n            </p:Adr>\n          </p:PstlAdr>\n        </p:RmtLctnDtls>\n      </p:RltdRmtInf>\n      <p:RmtInf>\n\t\t\n        <p:Strd>\n          <p:RfrdDocInf>\n            <p:Tp>\n              <p:CdOrPrtry>\n                <p:Cd>CINV</p:Cd>\n              </p:CdOrPrtry>\n              <p:Issr>pac008</p:Issr>\n            </p:Tp>\n            <p:Nb>INV-09123</p:Nb>\n            <p:RltdDt>2023-02-06</p:RltdDt>\n            <p:LineDtls>\n              <p:Id>\n                <p:Tp>\n                  <p:CdOrPrtry>\n                    <p:Cd>008</p:Cd>\n                  </p:CdOrPrtry>\n                  <p:Issr>pac008</p:Issr>\n                </p:Tp>\n                <p:Nb>2</p:Nb>\n                <p:RltdDt>2001-01-01</p:RltdDt>\n              </p:Id>\n              <p:Desc>CreditorTransfer</p:Desc>\n              <p:Amt>\n                <p:DuePyblAmt Ccy=\"USD\">10.05</p:DuePyblAmt>\n                <p:DscntApldAmt>\n                  <p:Tp>\n                    <p:Cd>p:Cd</p:Cd>\n                  </p:Tp>\n                  <p:Amt Ccy=\"USD\">10.90</p:Amt>\n                </p:DscntApldAmt>\n                <p:CdtNoteAmt Ccy=\"USD\">20.0</p:CdtNoteAmt>\n                <p:TaxAmt>\n                  <p:Tp>\n                    <p:Cd>008</p:Cd>\n                  </p:Tp>\n                  <p:Amt Ccy=\"USD\">12.34</p:Amt>\n                </p:TaxAmt>\n                <p:AdjstmntAmtAndRsn>\n                  <p:Amt Ccy=\"USD\">14.80</p:Amt>\n                  <p:CdtDbtInd>CRDT</p:CdtDbtInd>\n                  <p:Rsn>PACS</p:Rsn>\n                  <p:AddtlInf>Customer Credit transfer</p:AddtlInf>\n                </p:AdjstmntAmtAndRsn>\n                <p:RmtdAmt Ccy=\"USD\">13.89</p:RmtdAmt>\n              </p:Amt>\n            </p:LineDtls>\n          </p:RfrdDocInf>\n          <p:RfrdDocAmt>\n            <p:DuePyblAmt Ccy=\"USD\">10.04</p:DuePyblAmt>\n            <p:DscntApldAmt>\n              <p:Tp>\n                <p:Cd>008</p:Cd>\n              </p:Tp>\n              <p:Amt Ccy=\"USD\">0.98</p:Amt>\n            </p:DscntApldAmt>\n            <p:CdtNoteAmt Ccy=\"USD\">9.50</p:CdtNoteAmt>\n            <p:TaxAmt>\n              <p:Tp>\n                <p:Cd>12</p:Cd>\n              </p:Tp>\n              <p:Amt Ccy=\"USD\">4.56</p:Amt>\n            </p:TaxAmt>\n            <p:AdjstmntAmtAndRsn>\n              <p:Amt Ccy=\"USD\">5.90</p:Amt>\n              <p:CdtDbtInd>CRDT</p:CdtDbtInd>\n              <p:Rsn>PACS</p:Rsn>\n              <p:AddtlInf>CREDITOR transfer</p:AddtlInf>\n            </p:AdjstmntAmtAndRsn>\n            <p:RmtdAmt Ccy=\"USD\">7.90</p:RmtdAmt>\n          </p:RfrdDocAmt>\n          <p:CdtrRefInf>\n            <p:Tp>\n              <p:CdOrPrtry>\n                <p:Cd>RADM</p:Cd>\n              </p:CdOrPrtry>\n              <p:Issr>PAC008</p:Issr>\n            </p:Tp>\n            <p:Ref>Ref008</p:Ref>\n          </p:CdtrRefInf>\n          <p:Invcr>\n            <p:Nm>Janet Aro</p:Nm>\n            <p:PstlAdr>\n              <p:AdrTp>\n                <p:Cd>ADDR</p:Cd>\n              </p:AdrTp>\n              <p:Dept>Finance</p:Dept>\n              <p:SubDept>Accounts Payable</p:SubDept>\n              <p:StrtNm>Main Street</p:StrtNm>\n              <p:BldgNb>Unit 81</p:BldgNb>\n              <p:BldgNm>Keepers</p:BldgNm>\n              <p:Flr>1st floor</p:Flr>\n              <p:PstBx>1</p:PstBx>\n              <p:Room>34</p:Room>\n              <p:PstCd>92262</p:PstCd>\n              <p:TwnNm>New york</p:TwnNm>\n              <p:TwnLctnNm>Auburn</p:TwnLctnNm>\n              <p:DstrctNm>Alabama</p:DstrctNm>\n              <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n              <p:Ctry>US</p:Ctry>\n              <p:AdrLine>500 Main Street</p:AdrLine>\n            </p:PstlAdr>\n            <p:Id>\n              <p:OrgId>\n                <p:AnyBIC>AW12CYQ1B56</p:AnyBIC>\n                <p:LEI>1ZM4S5E1J6I8P9H1Q034</p:LEI>\n                <p:Othr>\n                  <p:Id>124</p:Id>\n                  <p:SchmeNm>\n                    <p:Cd>0081</p:Cd>\n                  </p:SchmeNm>\n                  <p:Issr>pac008</p:Issr>\n                </p:Othr>\n              </p:OrgId>\n            </p:Id>\n            <p:CtryOfRes>US</p:CtryOfRes>\n            <p:CtctDtls>\n              <p:NmPrfx>DOCT</p:NmPrfx>\n              <p:Nm>Mary Grace</p:Nm>\n              <p:PhneNb>+1-456-890-8745</p:PhneNb>\n              <p:MobNb>+1-999-234-0987</p:MobNb>\n              <p:FaxNb>+1-212-9877887</p:FaxNb>\n              <p:EmailAdr>MaryGrace@Corporation.com</p:EmailAdr>\n              <p:EmailPurp>CreditTransfer</p:EmailPurp>\n              <p:JobTitl>Transfer</p:JobTitl>\n              <p:Rspnsblty>Payment</p:Rspnsblty>\n              <p:Dept>Service</p:Dept>\n              <p:Othr>\n                <p:ChanlTp>CCT</p:ChanlTp>\n                <p:Id>p:Id</p:Id>\n              </p:Othr>\n              <p:PrefrdMtd>LETT</p:PrefrdMtd>\n            </p:CtctDtls>\n          </p:Invcr>\n          <p:Invcee>\n            <p:Nm>Adam Charles</p:Nm>\n            <p:PstlAdr>\n              <p:AdrTp>\n                <p:Cd>ADDR</p:Cd>\n              </p:AdrTp>\n              <p:Dept>Finance</p:Dept>\n              <p:SubDept>Accounts Payable</p:SubDept>\n              <p:StrtNm>Avenue of the Fountains</p:StrtNm>\n              <p:BldgNb>Suite D110</p:BldgNb>\n              <p:BldgNm>Glora Heights</p:BldgNm>\n              <p:Flr>1st Floor</p:Flr>\n              <p:PstBx>1</p:PstBx>\n              <p:Room>48</p:Room>\n              <p:PstCd>97035</p:PstCd>\n              <p:TwnNm>Portland</p:TwnNm>\n              <p:TwnLctnNm>Aakshs</p:TwnLctnNm>\n              <p:DstrctNm>Taxas</p:DstrctNm>\n              <p:CtrySubDvsn>OR</p:CtrySubDvsn>\n              <p:Ctry>US</p:Ctry>\n              <p:AdrLine>435 Avenue of the Fountains</p:AdrLine>\n            </p:PstlAdr>\n            <p:Id>\n              <p:OrgId>\n                <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                <p:Othr>\n                  <p:Id>345</p:Id>\n                  <p:SchmeNm>\n                    <p:Cd>008</p:Cd>\n                  </p:SchmeNm>\n                  <p:Issr>PACS</p:Issr>\n                </p:Othr>\n              </p:OrgId>\n            </p:Id>\n            <p:CtryOfRes>OR</p:CtryOfRes>\n            <p:CtctDtls>\n              <p:NmPrfx>DOCT</p:NmPrfx>\n              <p:Nm>Adam Charles</p:Nm>\n              <p:PhneNb>+1-897-098-0987</p:PhneNb>\n              <p:MobNb>+1-672-445-8753</p:MobNb>\n              <p:FaxNb>+1-624-7264562</p:FaxNb>\n              <p:EmailAdr>Adamcharles@Corporation.com</p:EmailAdr>\n              <p:EmailPurp>CreditorTransfer</p:EmailPurp>\n              <p:JobTitl>payment information</p:JobTitl>\n              <p:Rspnsblty>payment</p:Rspnsblty>\n              <p:Dept>SDervice</p:Dept>\n              <p:Othr>\n                <p:ChanlTp>CCT</p:ChanlTp>\n                <p:Id>23</p:Id>\n              </p:Othr>\n              <p:PrefrdMtd>LETT</p:PrefrdMtd>\n            </p:CtctDtls>\n          </p:Invcee>\n          <p:TaxRmt>\n            <p:Cdtr>\n              <p:TaxId>CD435</p:TaxId>\n              <p:RegnId>US125</p:RegnId>\n              <p:TaxTp>IT</p:TaxTp>\n            </p:Cdtr>\n            <p:Dbtr>\n              <p:TaxId>DF89</p:TaxId>\n              <p:RegnId>US6723</p:RegnId>\n              <p:TaxTp>HRA</p:TaxTp>\n              <p:Authstn>\n                <p:Titl>Mrs</p:Titl>\n                <p:Nm>Sarah Jane</p:Nm>\n              </p:Authstn>\n            </p:Dbtr>\n            <p:UltmtDbtr>\n              <p:TaxId>1270</p:TaxId>\n              <p:RegnId>US40923</p:RegnId>\n              <p:TaxTp>GPA</p:TaxTp>\n              <p:Authstn>\n                <p:Titl>MR</p:Titl>\n                <p:Nm>Neil Mathew</p:Nm>\n              </p:Authstn>\n            </p:UltmtDbtr>\n            <p:AdmstnZone>p:AdmstnZone</p:AdmstnZone>\n            <p:RefNb>p:RefNb</p:RefNb>\n            <p:Mtd>p:Mtd</p:Mtd>\n            <p:TtlTaxblBaseAmt Ccy=\"USD\">10.50</p:TtlTaxblBaseAmt>\n            <p:TtlTaxAmt Ccy=\"USD\">40.0</p:TtlTaxAmt>\n            <p:Dt>2001-01-01</p:Dt>\n            <p:SeqNb>0.0</p:SeqNb>\n            <p:Rcrd>\n              <p:Tp>saving</p:Tp>\n              <p:Ctgy>Loan</p:Ctgy>\n              <p:CtgyDtls>Personal loan</p:CtgyDtls>\n              <p:DbtrSts>Active</p:DbtrSts>\n              <p:CertId>128976</p:CertId>\n              <p:FrmsCd>FMS763</p:FrmsCd>\n              <p:Prd>\n                <p:Yr>2001-01-01</p:Yr>\n                <p:Tp>MM01</p:Tp>\n                <p:FrToDt>\n                  <p:FrDt>2001-01-01</p:FrDt>\n                  <p:ToDt>2001-01-01</p:ToDt>\n                </p:FrToDt>\n              </p:Prd>\n              <p:TaxAmt>\n                <p:Rate>0.0</p:Rate>\n                <p:TaxblBaseAmt Ccy=\"USD\">10.0</p:TaxblBaseAmt>\n                <p:TtlAmt Ccy=\"USD\">9.0</p:TtlAmt>\n                <p:Dtls>\n                  <p:Prd>\n                    <p:Yr>2001-01-01</p:Yr>\n                    <p:Tp>MM01</p:Tp>\n                    <p:FrToDt>\n                      <p:FrDt>2001-01-01</p:FrDt>\n                      <p:ToDt>2001-01-01</p:ToDt>\n                    </p:FrToDt>\n                  </p:Prd>\n                  <p:Amt Ccy=\"USD\">10.10</p:Amt>\n                </p:Dtls>\n              </p:TaxAmt>\n              <p:AddtlInf>p:AddtlInf</p:AddtlInf>\n            </p:Rcrd>\n          </p:TaxRmt>\n          <p:GrnshmtRmt>\n            <p:Tp>\n              <p:CdOrPrtry>\n                <p:Cd>012</p:Cd>\n              </p:CdOrPrtry>\n              <p:Issr>pac008</p:Issr>\n            </p:Tp>\n            <p:Grnshee>\n              <p:Nm>Abigail Simon</p:Nm>\n              <p:PstlAdr>\n                <p:AdrTp>\n                  <p:Cd>ADDR</p:Cd>\n                </p:AdrTp>\n                <p:Dept>Finance</p:Dept>\n                <p:SubDept>Accounts Payable</p:SubDept>\n                <p:StrtNm>3rd street Maple ave</p:StrtNm>\n                <p:BldgNb>12</p:BldgNb>\n                <p:BldgNm>Ocen Edge</p:BldgNm>\n                <p:Flr>12</p:Flr>\n                <p:PstBx>345</p:PstBx>\n                <p:Room>45</p:Room>\n                <p:PstCd>89012</p:PstCd>\n                <p:TwnNm>Berkeley</p:TwnNm>\n                <p:TwnLctnNm>California</p:TwnLctnNm>\n                <p:DstrctNm>California</p:DstrctNm>\n                <p:CtrySubDvsn>CA</p:CtrySubDvsn>\n                <p:Ctry>US</p:Ctry>\n                <p:AdrLine>p:AdrLine</p:AdrLine>\n              </p:PstlAdr>\n              <p:Id>\n                <p:OrgId>\n                  <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                  <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                  <p:Othr>\n                    <p:Id>p:Id</p:Id>\n                    <p:SchmeNm>\n                      <p:Cd>p:Cd</p:Cd>\n                    </p:SchmeNm>\n                    <p:Issr>p:Issr</p:Issr>\n                  </p:Othr>\n                </p:OrgId>\n              </p:Id>\n              <p:CtryOfRes>US</p:CtryOfRes>\n              <p:CtctDtls>\n                <p:NmPrfx>DOCT</p:NmPrfx>\n                <p:Nm>Abigail Simon</p:Nm>\n                <p:PhneNb>+1-555-490-5690</p:PhneNb>\n                <p:MobNb>+1-098-445-3839</p:MobNb>\n                <p:FaxNb>+1-555-12875</p:FaxNb>\n                <p:EmailAdr>abigail_simon</p:EmailAdr>\n                <p:EmailPurp>Mailing</p:EmailPurp>\n                <p:JobTitl>HR</p:JobTitl>\n                <p:Rspnsblty>Administration</p:Rspnsblty>\n                <p:Dept>Finance</p:Dept>\n                <p:Othr>\n                  <p:ChanlTp>CH58</p:ChanlTp>\n                  <p:Id>487</p:Id>\n                </p:Othr>\n                <p:PrefrdMtd>LETT</p:PrefrdMtd>\n              </p:CtctDtls>\n            </p:Grnshee>\n            <p:GrnshmtAdmstr>\n              <p:Nm>loordz Faustina</p:Nm>\n              <p:PstlAdr>\n                <p:AdrTp>\n                  <p:Cd>ADDR</p:Cd>\n                </p:AdrTp>\n                <p:Dept>Finance</p:Dept>\n                <p:SubDept>Accounts Payable</p:SubDept>\n                <p:StrtNm>4th maple ave</p:StrtNm>\n                <p:BldgNb>34</p:BldgNb>\n                <p:BldgNm>Wish Stone</p:BldgNm>\n                <p:Flr>Ground Floor</p:Flr>\n                <p:PstBx>21</p:PstBx>\n                <p:Room>1124</p:Room>\n                <p:PstCd>7612</p:PstCd>\n                <p:TwnNm>Bakersfield</p:TwnNm>\n                <p:TwnLctnNm>California</p:TwnLctnNm>\n                <p:DstrctNm>California</p:DstrctNm>\n                <p:CtrySubDvsn>CAn</p:CtrySubDvsn>\n                <p:Ctry>US</p:Ctry>\n                <p:AdrLine>4th Maple Ave</p:AdrLine>\n              </p:PstlAdr>\n              <p:Id>\n                <p:OrgId>\n                  <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                  <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                  <p:Othr>\n                    <p:Id>p:Id</p:Id>\n                    <p:SchmeNm>\n                      <p:Cd>p:Cd</p:Cd>\n                    </p:SchmeNm>\n                    <p:Issr>p:Issr</p:Issr>\n                  </p:Othr>\n                </p:OrgId>\n              </p:Id>\n              <p:CtryOfRes>US</p:CtryOfRes>\n              <p:CtctDtls>\n                <p:NmPrfx>DOCT</p:NmPrfx>\n                <p:Nm>Loordz Faustina</p:Nm>\n                <p:PhneNb>+1-555-0923</p:PhneNb>\n                <p:MobNb>+1-987-678-2134</p:MobNb>\n                <p:FaxNb>+1-23-34567</p:FaxNb>\n                <p:EmailAdr>Loordz_Faustina</p:EmailAdr>\n                <p:EmailPurp>Business</p:EmailPurp>\n                <p:JobTitl>Owner</p:JobTitl>\n                <p:Rspnsblty>Admin</p:Rspnsblty>\n                <p:Dept>Finance</p:Dept>\n                <p:Othr>\n                  <p:ChanlTp>BUIZ</p:ChanlTp>\n                  <p:Id>14</p:Id>\n                </p:Othr>\n                <p:PrefrdMtd>LETT</p:PrefrdMtd>\n              </p:CtctDtls>\n            </p:GrnshmtAdmstr>\n            <p:RefNb>p:RefNb</p:RefNb>\n            <p:Dt>2001-01-01</p:Dt>\n            <p:RmtdAmt Ccy=\"USD\">10.0</p:RmtdAmt>\n            <p:FmlyMdclInsrncInd>true</p:FmlyMdclInsrncInd>\n            <p:MplyeeTermntnInd>true</p:MplyeeTermntnInd>\n          </p:GrnshmtRmt>\n          <p:AddtlRmtInf>p:AddtlRmtInf</p:AddtlRmtInf>\n        </p:Strd>\n      </p:RmtInf>\n    </p:CdtTrfTxInf>\n  </p:FIToFICstmrCdtTrf>\n</p:Document>",
            "timeStamp": "2023-05-15T19:17:11.010+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": "021040079",
            "creditorAccID": "61111000001",
            "status": null
        },
        {
            "messageId": "20230515021040078jGEuvmkFm25336925",
            "messageStatus": "IB_REQ_FNS_TO_PGW",
            "messageType": "pacs.008.001.08",
            "messageStatusDescription": "Inbound request from Fednow Simulator to Payment Gateway",
            "message": "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<p:Document xmlns:p=\"urn:iso:std:iso:20022:tech:xsd:pacs.008.001.08\" xmlns:h=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02\">\n    <h:AppHdr>\n        <h:Fr>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021150706</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:Fr>\n        <h:To>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021040079</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:To>\n        <h:BizMsgIdr>20230516021150706eJgTbPaLM64349910</h:BizMsgIdr>\n        <h:MsgDefIdr>pacs.008.001.08</h:MsgDefIdr>\n        <h:MktPrctc>\n            <h:Regy>www2.swift.com/mystandards/#/group/Federal_Reserve_Financial_Services/FedNow_Service</h:Regy>\n            <h:Id>frb.fednow.01</h:Id>\n        </h:MktPrctc>\n        <h:CreDt>2023-05-15T15:17:11-04:00</h:CreDt>\n        <h:BizPrcgDt>2023-05-15T15:17:10-04:00</h:BizPrcgDt>\n    </h:AppHdr>\n    <p:FIToFICstmrCdtTrf>\n        <p:GrpHdr>\n            <p:MsgId>20230515021040078jGEuvmkFm25336925</p:MsgId>\n            <p:CreDtTm>2023-05-15T19:17:10</p:CreDtTm>\n            <p:NbOfTxs>1</p:NbOfTxs>\n            <p:SttlmInf>\n                <p:SttlmMtd>CLRG</p:SttlmMtd>\n                <p:ClrSys>\n                    <p:Cd>FDN</p:Cd>\n                </p:ClrSys>\n            </p:SttlmInf>\n        </p:GrpHdr>\n        <p:CdtTrfTxInf>\n            <p:PmtId>\n                <p:InstrId>eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq</p:InstrId>\n                <p:EndToEndId>nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f</p:EndToEndId>\n                <p:TxId>vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr</p:TxId>\n                <p:UETR>462c23a1-bff1-48e2-922b-86b96f88e89d</p:UETR>\n            </p:PmtId>\n            <p:PmtTpInf>\n                <p:SvcLvl>\n                    <p:Cd>SEPA</p:Cd>\n                </p:SvcLvl>\n                <p:LclInstrm>\n                    <p:Prtry>FDNA</p:Prtry>\n                </p:LclInstrm>\n                <p:CtgyPurp>\n                    <p:Prtry>CONS</p:Prtry>\n                </p:CtgyPurp>\n            </p:PmtTpInf>\n            <p:IntrBkSttlmAmt Ccy=\"USD\">12.05</p:IntrBkSttlmAmt>\n            <p:IntrBkSttlmDt>2023-05-15</p:IntrBkSttlmDt>\n            <p:ChrgBr>SLEV</p:ChrgBr>\n            <p:InstgAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040078</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstgAgt>\n            <p:InstdAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040079</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstdAgt>\n            <p:UltmtDbtr>\n                <p:Nm>John Wick</p:Nm>\n                <p:PstlAdr>\n                    <p:Dept>Finance</p:Dept>\n                    <p:SubDept>Accounts Payable</p:SubDept>\n                    <p:StrtNm>9th Avenue</p:StrtNm>\n                    <p:BldgNb>12</p:BldgNb>\n                    <p:BldgNm>Max Towers</p:BldgNm>\n                    <p:Flr>3rd Floor</p:Flr>\n                    <p:PstBx>1180</p:PstBx>\n                    <p:Room>257</p:Room>\n                    <p:PstCd>AB6654F</p:PstCd>\n                    <p:TwnNm>New York</p:TwnNm>\n                    <p:TwnLctnNm>Alexzander city</p:TwnLctnNm>\n                    <p:DstrctNm>Alabama</p:DstrctNm>\n                    <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                    <p:Ctry>US</p:Ctry>\n                    <p:AdrLine>3rd Dream Road</p:AdrLine>\n                </p:PstlAdr>\n                <p:Id>\n                    <p:OrgId>\n                        <p:AnyBIC>AS12CDQ1B56</p:AnyBIC>\n                        <p:LEI>1AC4D5E1G6I8J9H0H034</p:LEI>\n                        <p:Othr>\n                            <p:Id>31234568</p:Id>\n                            <p:SchmeNm>\n                                <p:Cd>008</p:Cd>\n                            </p:SchmeNm>\n                            <p:Issr>PAC008</p:Issr>\n                        </p:Othr>\n                    </p:OrgId>\n                </p:Id>\n                <p:CtryOfRes>US</p:CtryOfRes>\n            </p:UltmtDbtr>\n            <p:InitgPty>\n                <p:Nm>Sarah Jane</p:Nm>\n                <p:PstlAdr>\n                    <p:Dept>Finance</p:Dept>\n                    <p:SubDept>Accounts Payable</p:SubDept>\n                    <p:StrtNm>Dream Road</p:StrtNm>\n                    <p:BldgNb>141</p:BldgNb>\n                    <p:BldgNm>Dream Aura</p:BldgNm>\n                    <p:Flr>2nd floor</p:Flr>\n                    <p:PstBx>450</p:PstBx>\n                    <p:Room>204</p:Room>\n                    <p:PstCd>A654HG</p:PstCd>\n                    <p:TwnNm>New York</p:TwnNm>\n                    <p:TwnLctnNm>Alaskha</p:TwnLctnNm>\n                    <p:DstrctNm>Texas</p:DstrctNm>\n                    <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                    <p:Ctry>US</p:Ctry>\n                    <p:AdrLine>3rd Dream Road</p:AdrLine>\n                </p:PstlAdr>\n                <p:Id>\n                    <p:OrgId>\n                        <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n                        <p:LEI>1ZC4D5E1J6I8J9H1W034</p:LEI>\n                    </p:OrgId>\n                </p:Id>\n                <p:CtryOfRes>US</p:CtryOfRes>\n            </p:InitgPty>\n            <p:Dbtr>\n                <p:Nm>John Wick</p:Nm>\n                <p:PstlAdr>\n                    <p:Dept>Finance</p:Dept>\n                    <p:SubDept>Accounts Payable</p:SubDept>\n                    <p:StrtNm>Oxford Road</p:StrtNm>\n                    <p:BldgNb>Unit 143</p:BldgNb>\n                    <p:BldgNm>Max Towers</p:BldgNm>\n                    <p:Flr>2nd Floor</p:Flr>\n                    <p:PstBx>19067</p:PstBx>\n                    <p:Room>345</p:Room>\n                    <p:PstCd>AB6654F</p:PstCd>\n                    <p:TwnNm>New York</p:TwnNm>\n                    <p:TwnLctnNm>ARIZONA</p:TwnLctnNm>\n                    <p:DstrctNm>ARIZONA</p:DstrctNm>\n                    <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                    <p:Ctry>US</p:Ctry>\n                    <p:AdrLine>3rd Dream Road</p:AdrLine>\n                </p:PstlAdr>\n                <p:Id>\n                    <p:OrgId>\n                        <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n                        <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n                        <p:Othr>\n                            <p:Id>31234567</p:Id>\n                            <p:SchmeNm>\n                                <p:Cd>008</p:Cd>\n                            </p:SchmeNm>\n                            <p:Issr>Pac008</p:Issr>\n                        </p:Othr>\n                    </p:OrgId>\n                </p:Id>\n                <p:CtryOfRes>US</p:CtryOfRes>\n            </p:Dbtr>\n            <p:DbtrAcct>\n                <p:Id>\n                    <p:Othr>\n                        <p:Id>11111000001</p:Id>\n                    </p:Othr>\n                </p:Id>\n                <p:Tp>\n                    <p:Cd>CASH</p:Cd>\n                </p:Tp>\n                <p:Prxy>\n                    <p:Tp>\n                        <p:Cd>TELE</p:Cd>\n                    </p:Tp>\n                    <p:Id>19765836524</p:Id>\n                </p:Prxy>\n            </p:DbtrAcct>\n            <p:DbtrAgt>\n                <p:FinInstnId>\n                    <p:BICFI>BE20USS8</p:BICFI>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040078</p:MmbId>\n                    </p:ClrSysMmbId>\n                    <p:LEI>1AS2DF34GH45M9L08E09</p:LEI>\n                    <p:Nm>Micheal Ryan</p:Nm>\n                    <p:PstlAdr>\n                        <p:Dept>Finance</p:Dept>\n                        <p:SubDept>Accounts Payable</p:SubDept>\n                        <p:StrtNm>Avenue of the Fountains</p:StrtNm>\n                        <p:BldgNb>Suite D110</p:BldgNb>\n                        <p:BldgNm>Keepers</p:BldgNm>\n                        <p:Flr>6th Floor</p:Flr>\n                        <p:PstBx>1</p:PstBx>\n                        <p:Room>567</p:Room>\n                        <p:PstCd>85268</p:PstCd>\n                        <p:TwnNm>Fountain Hills</p:TwnNm>\n                        <p:TwnLctnNm>Phenix City</p:TwnLctnNm>\n                        <p:DstrctNm>Alabama</p:DstrctNm>\n                        <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n                        <p:Ctry>US</p:Ctry>\n                        <p:AdrLine>3rd Dream Road</p:AdrLine>\n                    </p:PstlAdr>\n                </p:FinInstnId>\n            </p:DbtrAgt>\n            <p:CdtrAgt>\n                <p:FinInstnId>\n                    <p:BICFI>FA16USS8</p:BICFI>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040079</p:MmbId>\n                    </p:ClrSysMmbId>\n                    <p:LEI>1AS2DF34GH45M9L08E09</p:LEI>\n                    <p:Nm>Neil Mathew</p:Nm>\n                    <p:PstlAdr>\n                        <p:Dept>Finance</p:Dept>\n                        <p:SubDept>Accounts Payable</p:SubDept>\n                        <p:StrtNm>Dream Road</p:StrtNm>\n                        <p:BldgNb>Unit 81</p:BldgNb>\n                        <p:BldgNm>New View</p:BldgNm>\n                        <p:Flr>1st Floor</p:Flr>\n                        <p:PstBx>1</p:PstBx>\n                        <p:Room>56</p:Room>\n                        <p:PstCd>10001</p:PstCd>\n                        <p:TwnNm>New York</p:TwnNm>\n                        <p:TwnLctnNm>ALAMEDA</p:TwnLctnNm>\n                        <p:DstrctNm>California</p:DstrctNm>\n                        <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                        <p:Ctry>US</p:Ctry>\n                        <p:AdrLine>25 Dream Road</p:AdrLine>\n                    </p:PstlAdr>\n                </p:FinInstnId>\n            </p:CdtrAgt>\n            <p:Cdtr>\n                <p:Nm>Max Smith</p:Nm>\n                <p:PstlAdr>\n                    <p:Dept>Finance</p:Dept>\n                    <p:SubDept>Accounts Payable</p:SubDept>\n                    <p:StrtNm>Ocean Street</p:StrtNm>\n                    <p:BldgNb>UNit 6</p:BldgNb>\n                    <p:BldgNm>Rose Garden</p:BldgNm>\n                    <p:Flr>3rd Floor</p:Flr>\n                    <p:PstBx>1</p:PstBx>\n                    <p:Room>456</p:Room>\n                    <p:PstCd>GF5437Y</p:PstCd>\n                    <p:TwnNm>Riverside</p:TwnNm>\n                    <p:TwnLctnNm>D Land</p:TwnLctnNm>\n                    <p:DstrctNm>Florida</p:DstrctNm>\n                    <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n                    <p:Ctry>US</p:Ctry>\n                    <p:AdrLine>3rd Dream Road</p:AdrLine>\n                </p:PstlAdr>\n                <p:Id>\n                    <p:OrgId>\n                        <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n                        <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n                        <p:Othr>\n                            <p:Id>31234567</p:Id>\n                            <p:SchmeNm>\n                                <p:Cd>008</p:Cd>\n                            </p:SchmeNm>\n                            <p:Issr>pac008</p:Issr>\n                        </p:Othr>\n                    </p:OrgId>\n                </p:Id>\n                <p:CtryOfRes>US</p:CtryOfRes>\n            </p:Cdtr>\n            <p:CdtrAcct>\n                <p:Id>\n                    <p:Othr>\n                        <p:Id>61111000001</p:Id>\n                    </p:Othr>\n                </p:Id>\n                <p:Tp>\n                    <p:Cd>CASH</p:Cd>\n                </p:Tp>\n                <p:Prxy>\n                    <p:Tp>\n                        <p:Cd>TELE</p:Cd>\n                    </p:Tp>\n                    <p:Id>18764562487</p:Id>\n                </p:Prxy>\n            </p:CdtrAcct>\n            <p:UltmtCdtr>\n                <p:Nm>Sarah Jane</p:Nm>\n                <p:PstlAdr>\n                    <p:Dept>Finance</p:Dept>\n                    <p:SubDept>Accounts Payable</p:SubDept>\n                    <p:StrtNm>Dream Road</p:StrtNm>\n                    <p:BldgNb>Unit 81</p:BldgNb>\n                    <p:BldgNm>Dream Aura</p:BldgNm>\n                    <p:Flr>2nd Floor</p:Flr>\n                    <p:PstBx>1</p:PstBx>\n                    <p:Room>45</p:Room>\n                    <p:PstCd>A654HG</p:PstCd>\n                    <p:TwnNm>New York</p:TwnNm>\n                    <p:TwnLctnNm>Alameda</p:TwnLctnNm>\n                    <p:DstrctNm>California</p:DstrctNm>\n                    <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                    <p:Ctry>US</p:Ctry>\n                    <p:AdrLine>3rd Dream Road</p:AdrLine>\n                </p:PstlAdr>\n                <p:Id>\n                    <p:OrgId>\n                        <p:AnyBIC>VB12CYQ1B56</p:AnyBIC>\n                        <p:LEI>1ZC4S5E1J6I8J9H1Q034</p:LEI>\n                        <p:Othr>\n                            <p:Id>763455</p:Id>\n                            <p:SchmeNm>\n                                <p:Cd>008</p:Cd>\n                            </p:SchmeNm>\n                            <p:Issr>pac008</p:Issr>\n                        </p:Othr>\n                    </p:OrgId>\n                </p:Id>\n                <p:CtryOfRes>US</p:CtryOfRes>\n            </p:UltmtCdtr>\n            <p:Purp>\n                <p:Cd>ACCT</p:Cd>\n            </p:Purp>\n            <p:RltdRmtInf>\n                <p:RmtId>Remittance 432</p:RmtId>\n                <p:RmtLctnDtls>\n                    <p:Mtd>FAXI</p:Mtd>\n                    <p:ElctrncAdr>Marygrace_123</p:ElctrncAdr>\n                    <p:PstlAdr>\n                        <p:Nm>Bella Jean</p:Nm>\n                        <p:Adr>\n                            <p:Dept>Finance</p:Dept>\n                            <p:SubDept>Accounts Payable</p:SubDept>\n                            <p:StrtNm>RailRoad Ave</p:StrtNm>\n                            <p:BldgNb>unit 81</p:BldgNb>\n                            <p:BldgNm>Happy Villege</p:BldgNm>\n                            <p:Flr>1st Floor</p:Flr>\n                            <p:PstBx>2</p:PstBx>\n                            <p:Room>34</p:Room>\n                            <p:PstCd>14561</p:PstCd>\n                            <p:TwnNm>palm Springs</p:TwnNm>\n                            <p:TwnLctnNm>Athens</p:TwnLctnNm>\n                            <p:DstrctNm>Alabama</p:DstrctNm>\n                            <p:CtrySubDvsn>AZ</p:CtrySubDvsn>\n                            <p:Ctry>US</p:Ctry>\n                            <p:AdrLine>1 RailRoad Ave</p:AdrLine>\n                        </p:Adr>\n                    </p:PstlAdr>\n                </p:RmtLctnDtls>\n            </p:RltdRmtInf>\n            <p:RmtInf>\n                <p:Strd>\n                    <p:RfrdDocInf>\n                        <p:Tp>\n                            <p:CdOrPrtry>\n                                <p:Cd>CINV</p:Cd>\n                            </p:CdOrPrtry>\n                            <p:Issr>pac008</p:Issr>\n                        </p:Tp>\n                        <p:Nb>INV-09123</p:Nb>\n                        <p:RltdDt>2023-02-06</p:RltdDt>\n                        <p:LineDtls>\n                            <p:Id>\n                                <p:Tp>\n                                    <p:CdOrPrtry>\n                                        <p:Cd>008</p:Cd>\n                                    </p:CdOrPrtry>\n                                    <p:Issr>pac008</p:Issr>\n                                </p:Tp>\n                                <p:Nb>2</p:Nb>\n                                <p:RltdDt>2001-01-01</p:RltdDt>\n                            </p:Id>\n                            <p:Desc>CreditorTransfer</p:Desc>\n                            <p:Amt>\n                                <p:DuePyblAmt Ccy=\"USD\">10.05</p:DuePyblAmt>\n                                <p:DscntApldAmt>\n                                    <p:Tp>\n                                        <p:Cd>p:Cd</p:Cd>\n                                    </p:Tp>\n                                    <p:Amt Ccy=\"USD\">10.9</p:Amt>\n                                </p:DscntApldAmt>\n                                <p:CdtNoteAmt Ccy=\"USD\">20.0</p:CdtNoteAmt>\n                                <p:TaxAmt>\n                                    <p:Tp>\n                                        <p:Cd>008</p:Cd>\n                                    </p:Tp>\n                                    <p:Amt Ccy=\"USD\">12.34</p:Amt>\n                                </p:TaxAmt>\n                                <p:AdjstmntAmtAndRsn>\n                                    <p:Amt Ccy=\"USD\">14.8</p:Amt>\n                                    <p:CdtDbtInd>CRDT</p:CdtDbtInd>\n                                    <p:Rsn>PACS</p:Rsn>\n                                    <p:AddtlInf>Customer Credit transfer</p:AddtlInf>\n                                </p:AdjstmntAmtAndRsn>\n                                <p:RmtdAmt Ccy=\"USD\">13.89</p:RmtdAmt>\n                            </p:Amt>\n                        </p:LineDtls>\n                    </p:RfrdDocInf>\n                    <p:RfrdDocAmt>\n                        <p:DuePyblAmt Ccy=\"USD\">10.04</p:DuePyblAmt>\n                        <p:DscntApldAmt>\n                            <p:Tp>\n                                <p:Cd>008</p:Cd>\n                            </p:Tp>\n                            <p:Amt Ccy=\"USD\">0.98</p:Amt>\n                        </p:DscntApldAmt>\n                        <p:CdtNoteAmt Ccy=\"USD\">9.5</p:CdtNoteAmt>\n                        <p:TaxAmt>\n                            <p:Tp>\n                                <p:Cd>12</p:Cd>\n                            </p:Tp>\n                            <p:Amt Ccy=\"USD\">4.56</p:Amt>\n                        </p:TaxAmt>\n                        <p:AdjstmntAmtAndRsn>\n                            <p:Amt Ccy=\"USD\">5.9</p:Amt>\n                            <p:CdtDbtInd>CRDT</p:CdtDbtInd>\n                            <p:Rsn>PACS</p:Rsn>\n                            <p:AddtlInf>CREDITOR transfer</p:AddtlInf>\n                        </p:AdjstmntAmtAndRsn>\n                        <p:RmtdAmt Ccy=\"USD\">7.9</p:RmtdAmt>\n                    </p:RfrdDocAmt>\n                    <p:CdtrRefInf>\n                        <p:Tp>\n                            <p:CdOrPrtry>\n                                <p:Cd>RADM</p:Cd>\n                            </p:CdOrPrtry>\n                            <p:Issr>PAC008</p:Issr>\n                        </p:Tp>\n                        <p:Ref>Ref008</p:Ref>\n                    </p:CdtrRefInf>\n                    <p:Invcr>\n                        <p:Nm>Janet Aro</p:Nm>\n                        <p:PstlAdr>\n                            <p:AdrTp>\n                                <p:Cd>ADDR</p:Cd>\n                            </p:AdrTp>\n                            <p:Dept>Finance</p:Dept>\n                            <p:SubDept>Accounts Payable</p:SubDept>\n                            <p:StrtNm>Main Street</p:StrtNm>\n                            <p:BldgNb>Unit 81</p:BldgNb>\n                            <p:BldgNm>Keepers</p:BldgNm>\n                            <p:Flr>1st floor</p:Flr>\n                            <p:PstBx>1</p:PstBx>\n                            <p:Room>34</p:Room>\n                            <p:PstCd>92262</p:PstCd>\n                            <p:TwnNm>New york</p:TwnNm>\n                            <p:TwnLctnNm>Auburn</p:TwnLctnNm>\n                            <p:DstrctNm>Alabama</p:DstrctNm>\n                            <p:CtrySubDvsn>NY</p:CtrySubDvsn>\n                            <p:Ctry>US</p:Ctry>\n                            <p:AdrLine>500 Main Street</p:AdrLine>\n                        </p:PstlAdr>\n                        <p:Id>\n                            <p:OrgId>\n                                <p:AnyBIC>AW12CYQ1B56</p:AnyBIC>\n                                <p:LEI>1ZM4S5E1J6I8P9H1Q034</p:LEI>\n                                <p:Othr>\n                                    <p:Id>124</p:Id>\n                                    <p:SchmeNm>\n                                        <p:Cd>0081</p:Cd>\n                                    </p:SchmeNm>\n                                    <p:Issr>pac008</p:Issr>\n                                </p:Othr>\n                            </p:OrgId>\n                        </p:Id>\n                        <p:CtryOfRes>US</p:CtryOfRes>\n                        <p:CtctDtls>\n                            <p:NmPrfx>DOCT</p:NmPrfx>\n                            <p:Nm>Mary Grace</p:Nm>\n                            <p:PhneNb>+1-456-890-8745</p:PhneNb>\n                            <p:MobNb>+1-999-234-0987</p:MobNb>\n                            <p:FaxNb>+1-212-9877887</p:FaxNb>\n                            <p:EmailAdr>MaryGrace@Corporation.com</p:EmailAdr>\n                            <p:EmailPurp>CreditTransfer</p:EmailPurp>\n                            <p:JobTitl>Transfer</p:JobTitl>\n                            <p:Rspnsblty>Payment</p:Rspnsblty>\n                            <p:Dept>Service</p:Dept>\n                            <p:Othr>\n                                <p:ChanlTp>CCT</p:ChanlTp>\n                                <p:Id>p:Id</p:Id>\n                            </p:Othr>\n                            <p:PrefrdMtd>LETT</p:PrefrdMtd>\n                        </p:CtctDtls>\n                    </p:Invcr>\n                    <p:Invcee>\n                        <p:Nm>Adam Charles</p:Nm>\n                        <p:PstlAdr>\n                            <p:AdrTp>\n                                <p:Cd>ADDR</p:Cd>\n                            </p:AdrTp>\n                            <p:Dept>Finance</p:Dept>\n                            <p:SubDept>Accounts Payable</p:SubDept>\n                            <p:StrtNm>Avenue of the Fountains</p:StrtNm>\n                            <p:BldgNb>Suite D110</p:BldgNb>\n                            <p:BldgNm>Glora Heights</p:BldgNm>\n                            <p:Flr>1st Floor</p:Flr>\n                            <p:PstBx>1</p:PstBx>\n                            <p:Room>48</p:Room>\n                            <p:PstCd>97035</p:PstCd>\n                            <p:TwnNm>Portland</p:TwnNm>\n                            <p:TwnLctnNm>Aakshs</p:TwnLctnNm>\n                            <p:DstrctNm>Taxas</p:DstrctNm>\n                            <p:CtrySubDvsn>OR</p:CtrySubDvsn>\n                            <p:Ctry>US</p:Ctry>\n                            <p:AdrLine>435 Avenue of the Fountains</p:AdrLine>\n                        </p:PstlAdr>\n                        <p:Id>\n                            <p:OrgId>\n                                <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                                <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                                <p:Othr>\n                                    <p:Id>345</p:Id>\n                                    <p:SchmeNm>\n                                        <p:Cd>008</p:Cd>\n                                    </p:SchmeNm>\n                                    <p:Issr>PACS</p:Issr>\n                                </p:Othr>\n                            </p:OrgId>\n                        </p:Id>\n                        <p:CtryOfRes>OR</p:CtryOfRes>\n                        <p:CtctDtls>\n                            <p:NmPrfx>DOCT</p:NmPrfx>\n                            <p:Nm>Adam Charles</p:Nm>\n                            <p:PhneNb>+1-897-098-0987</p:PhneNb>\n                            <p:MobNb>+1-672-445-8753</p:MobNb>\n                            <p:FaxNb>+1-624-7264562</p:FaxNb>\n                            <p:EmailAdr>Adamcharles@Corporation.com</p:EmailAdr>\n                            <p:EmailPurp>CreditorTransfer</p:EmailPurp>\n                            <p:JobTitl>payment information</p:JobTitl>\n                            <p:Rspnsblty>payment</p:Rspnsblty>\n                            <p:Dept>SDervice</p:Dept>\n                            <p:Othr>\n                                <p:ChanlTp>CCT</p:ChanlTp>\n                                <p:Id>23</p:Id>\n                            </p:Othr>\n                            <p:PrefrdMtd>LETT</p:PrefrdMtd>\n                        </p:CtctDtls>\n                    </p:Invcee>\n                    <p:TaxRmt>\n                        <p:Cdtr>\n                            <p:TaxId>CD435</p:TaxId>\n                            <p:RegnId>US125</p:RegnId>\n                            <p:TaxTp>IT</p:TaxTp>\n                        </p:Cdtr>\n                        <p:Dbtr>\n                            <p:TaxId>DF89</p:TaxId>\n                            <p:RegnId>US6723</p:RegnId>\n                            <p:TaxTp>HRA</p:TaxTp>\n                            <p:Authstn>\n                                <p:Titl>Mrs</p:Titl>\n                                <p:Nm>Sarah Jane</p:Nm>\n                            </p:Authstn>\n                        </p:Dbtr>\n                        <p:UltmtDbtr>\n                            <p:TaxId>1270</p:TaxId>\n                            <p:RegnId>US40923</p:RegnId>\n                            <p:TaxTp>GPA</p:TaxTp>\n                            <p:Authstn>\n                                <p:Titl>MR</p:Titl>\n                                <p:Nm>Neil Mathew</p:Nm>\n                            </p:Authstn>\n                        </p:UltmtDbtr>\n                        <p:AdmstnZone>p:AdmstnZone</p:AdmstnZone>\n                        <p:RefNb>p:RefNb</p:RefNb>\n                        <p:Mtd>p:Mtd</p:Mtd>\n                        <p:TtlTaxblBaseAmt Ccy=\"USD\">10.5</p:TtlTaxblBaseAmt>\n                        <p:TtlTaxAmt Ccy=\"USD\">40.0</p:TtlTaxAmt>\n                        <p:Dt>2001-01-01</p:Dt>\n                        <p:SeqNb>0.0</p:SeqNb>\n                        <p:Rcrd>\n                            <p:Tp>saving</p:Tp>\n                            <p:Ctgy>Loan</p:Ctgy>\n                            <p:CtgyDtls>Personal loan</p:CtgyDtls>\n                            <p:DbtrSts>Active</p:DbtrSts>\n                            <p:CertId>128976</p:CertId>\n                            <p:FrmsCd>FMS763</p:FrmsCd>\n                            <p:Prd>\n                                <p:Yr>2001-01-01</p:Yr>\n                                <p:Tp>MM01</p:Tp>\n                                <p:FrToDt>\n                                    <p:FrDt>2001-01-01</p:FrDt>\n                                    <p:ToDt>2001-01-01</p:ToDt>\n                                </p:FrToDt>\n                            </p:Prd>\n                            <p:TaxAmt>\n                                <p:Rate>0.0</p:Rate>\n                                <p:TaxblBaseAmt Ccy=\"USD\">10.0</p:TaxblBaseAmt>\n                                <p:TtlAmt Ccy=\"USD\">9.0</p:TtlAmt>\n                                <p:Dtls>\n                                    <p:Prd>\n                                        <p:Yr>2001-01-01</p:Yr>\n                                        <p:Tp>MM01</p:Tp>\n                                        <p:FrToDt>\n                                            <p:FrDt>2001-01-01</p:FrDt>\n                                            <p:ToDt>2001-01-01</p:ToDt>\n                                        </p:FrToDt>\n                                    </p:Prd>\n                                    <p:Amt Ccy=\"USD\">10.1</p:Amt>\n                                </p:Dtls>\n                            </p:TaxAmt>\n                            <p:AddtlInf>p:AddtlInf</p:AddtlInf>\n                        </p:Rcrd>\n                    </p:TaxRmt>\n                    <p:GrnshmtRmt>\n                        <p:Tp>\n                            <p:CdOrPrtry>\n                                <p:Cd>012</p:Cd>\n                            </p:CdOrPrtry>\n                            <p:Issr>pac008</p:Issr>\n                        </p:Tp>\n                        <p:Grnshee>\n                            <p:Nm>Abigail Simon</p:Nm>\n                            <p:PstlAdr>\n                                <p:AdrTp>\n                                    <p:Cd>ADDR</p:Cd>\n                                </p:AdrTp>\n                                <p:Dept>Finance</p:Dept>\n                                <p:SubDept>Accounts Payable</p:SubDept>\n                                <p:StrtNm>3rd street Maple ave</p:StrtNm>\n                                <p:BldgNb>12</p:BldgNb>\n                                <p:BldgNm>Ocen Edge</p:BldgNm>\n                                <p:Flr>12</p:Flr>\n                                <p:PstBx>345</p:PstBx>\n                                <p:Room>45</p:Room>\n                                <p:PstCd>89012</p:PstCd>\n                                <p:TwnNm>Berkeley</p:TwnNm>\n                                <p:TwnLctnNm>California</p:TwnLctnNm>\n                                <p:DstrctNm>California</p:DstrctNm>\n                                <p:CtrySubDvsn>CA</p:CtrySubDvsn>\n                                <p:Ctry>US</p:Ctry>\n                                <p:AdrLine>p:AdrLine</p:AdrLine>\n                            </p:PstlAdr>\n                            <p:Id>\n                                <p:OrgId>\n                                    <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                                    <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                                    <p:Othr>\n                                        <p:Id>p:Id</p:Id>\n                                        <p:SchmeNm>\n                                            <p:Cd>p:Cd</p:Cd>\n                                        </p:SchmeNm>\n                                        <p:Issr>p:Issr</p:Issr>\n                                    </p:Othr>\n                                </p:OrgId>\n                            </p:Id>\n                            <p:CtryOfRes>US</p:CtryOfRes>\n                            <p:CtctDtls>\n                                <p:NmPrfx>DOCT</p:NmPrfx>\n                                <p:Nm>Abigail Simon</p:Nm>\n                                <p:PhneNb>+1-555-490-5690</p:PhneNb>\n                                <p:MobNb>+1-098-445-3839</p:MobNb>\n                                <p:FaxNb>+1-555-12875</p:FaxNb>\n                                <p:EmailAdr>abigail_simon</p:EmailAdr>\n                                <p:EmailPurp>Mailing</p:EmailPurp>\n                                <p:JobTitl>HR</p:JobTitl>\n                                <p:Rspnsblty>Administration</p:Rspnsblty>\n                                <p:Dept>Finance</p:Dept>\n                                <p:Othr>\n                                    <p:ChanlTp>CH58</p:ChanlTp>\n                                    <p:Id>487</p:Id>\n                                </p:Othr>\n                                <p:PrefrdMtd>LETT</p:PrefrdMtd>\n                            </p:CtctDtls>\n                        </p:Grnshee>\n                        <p:GrnshmtAdmstr>\n                            <p:Nm>loordz Faustina</p:Nm>\n                            <p:PstlAdr>\n                                <p:AdrTp>\n                                    <p:Cd>ADDR</p:Cd>\n                                </p:AdrTp>\n                                <p:Dept>Finance</p:Dept>\n                                <p:SubDept>Accounts Payable</p:SubDept>\n                                <p:StrtNm>4th maple ave</p:StrtNm>\n                                <p:BldgNb>34</p:BldgNb>\n                                <p:BldgNm>Wish Stone</p:BldgNm>\n                                <p:Flr>Ground Floor</p:Flr>\n                                <p:PstBx>21</p:PstBx>\n                                <p:Room>1124</p:Room>\n                                <p:PstCd>7612</p:PstCd>\n                                <p:TwnNm>Bakersfield</p:TwnNm>\n                                <p:TwnLctnNm>California</p:TwnLctnNm>\n                                <p:DstrctNm>California</p:DstrctNm>\n                                <p:CtrySubDvsn>CAn</p:CtrySubDvsn>\n                                <p:Ctry>US</p:Ctry>\n                                <p:AdrLine>4th Maple Ave</p:AdrLine>\n                            </p:PstlAdr>\n                            <p:Id>\n                                <p:OrgId>\n                                    <p:AnyBIC>KJ12UJU4</p:AnyBIC>\n                                    <p:LEI>ER78D0D6C657Y7O9H765</p:LEI>\n                                    <p:Othr>\n                                        <p:Id>p:Id</p:Id>\n                                        <p:SchmeNm>\n                                            <p:Cd>p:Cd</p:Cd>\n                                        </p:SchmeNm>\n                                        <p:Issr>p:Issr</p:Issr>\n                                    </p:Othr>\n                                </p:OrgId>\n                            </p:Id>\n                            <p:CtryOfRes>US</p:CtryOfRes>\n                            <p:CtctDtls>\n                                <p:NmPrfx>DOCT</p:NmPrfx>\n                                <p:Nm>Loordz Faustina</p:Nm>\n                                <p:PhneNb>+1-555-0923</p:PhneNb>\n                                <p:MobNb>+1-987-678-2134</p:MobNb>\n                                <p:FaxNb>+1-23-34567</p:FaxNb>\n                                <p:EmailAdr>Loordz_Faustina</p:EmailAdr>\n                                <p:EmailPurp>Business</p:EmailPurp>\n                                <p:JobTitl>Owner</p:JobTitl>\n                                <p:Rspnsblty>Admin</p:Rspnsblty>\n                                <p:Dept>Finance</p:Dept>\n                                <p:Othr>\n                                    <p:ChanlTp>BUIZ</p:ChanlTp>\n                                    <p:Id>14</p:Id>\n                                </p:Othr>\n                                <p:PrefrdMtd>LETT</p:PrefrdMtd>\n                            </p:CtctDtls>\n                        </p:GrnshmtAdmstr>\n                        <p:RefNb>p:RefNb</p:RefNb>\n                        <p:Dt>2001-01-01</p:Dt>\n                        <p:RmtdAmt Ccy=\"USD\">10.0</p:RmtdAmt>\n                        <p:FmlyMdclInsrncInd>true</p:FmlyMdclInsrncInd>\n                        <p:MplyeeTermntnInd>true</p:MplyeeTermntnInd>\n                    </p:GrnshmtRmt>\n                    <p:AddtlRmtInf>p:AddtlRmtInf</p:AddtlRmtInf>\n                </p:Strd>\n            </p:RmtInf>\n        </p:CdtTrfTxInf>\n    </p:FIToFICstmrCdtTrf>\n</p:Document>\n",
            "timeStamp": "2023-05-15T19:17:11.210+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": null,
            "creditorAccID": null,
            "status": null
        },
        {
            "messageId": "20230516021040079LfEZQtXMJ01737948",
            "messageStatus": "IB_RES_PGW_TO_FNS",
            "messageType": "pacs.002.001.10",
            "messageStatusDescription": "Inbound response from Payment Gateway to Fednow Simulator",
            "message": "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<p:Document xmlns:p=\"urn:iso:std:iso:20022:tech:xsd:pacs.002.001.10\" xmlns:h=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02\">\n    <h:AppHdr>\n        <h:Fr>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021040079</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:Fr>\n        <h:To>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021150706</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:To>\n        <h:BizMsgIdr>20230516021040079LetioOWDk70202508</h:BizMsgIdr>\n        <h:MsgDefIdr>pacs.002.001.10</h:MsgDefIdr>\n        <h:MktPrctc>\n            <h:Regy>www2.swift.com/mystandards/#/group/Federal_Reserve_Financial_Services/FedNow_Service</h:Regy>\n            <h:Id>frb.fednow.01</h:Id>\n        </h:MktPrctc>\n        <h:CreDt>2023-05-15T19:17:11</h:CreDt>\n    </h:AppHdr>\n    <p:FIToFIPmtStsRpt>\n        <p:GrpHdr>\n            <p:MsgId>20230516021040079LfEZQtXMJ01737948</p:MsgId>\n            <p:CreDtTm>2023-05-15T19:17:11</p:CreDtTm>\n        </p:GrpHdr>\n        <p:TxInfAndSts>\n            <p:OrgnlGrpInf>\n                <p:OrgnlMsgId>20230515021040078jGEuvmkFm25336925</p:OrgnlMsgId>\n                <p:OrgnlMsgNmId>pacs.008.001.08</p:OrgnlMsgNmId>\n                <p:OrgnlCreDtTm>2023-05-15T19:17:10</p:OrgnlCreDtTm>\n            </p:OrgnlGrpInf>\n            <p:OrgnlInstrId>eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq</p:OrgnlInstrId>\n            <p:OrgnlEndToEndId>nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f</p:OrgnlEndToEndId>\n            <p:OrgnlTxId>vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr</p:OrgnlTxId>\n            <p:OrgnlUETR>462c23a1-bff1-48e2-922b-86b96f88e89d</p:OrgnlUETR>\n            <p:TxSts>RJCT</p:TxSts>\n            <p:StsRsnInf>\n                <p:Rsn>\n                    <p:Cd>NARR</p:Cd>\n                </p:Rsn>\n                <p:AddtlInf>Providing additional info</p:AddtlInf>\n            </p:StsRsnInf>\n            <p:InstgAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040079</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstgAgt>\n            <p:InstdAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040078</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstdAgt>\n        </p:TxInfAndSts>\n    </p:FIToFIPmtStsRpt>\n</p:Document>\n",
            "timeStamp": "2023-05-15T19:17:11.267+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": null,
            "creditorAccID": null,
            "status": "RJCT"
        },
        {
            "messageId": "20230516021150706qNQmPNEOj27845234",
            "messageStatus": "IB_RES_FNS_TO_FIS",
            "messageType": "pacs.002.001.10",
            "messageStatusDescription": "Inbound response from Fednow Simulator to Financial Institution",
            "message": "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<p:Document xmlns:p=\"urn:iso:std:iso:20022:tech:xsd:pacs.002.001.10\" xmlns:h=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02\">\n    <h:AppHdr>\n        <h:Fr>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021150706</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:Fr>\n        <h:To>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021040078</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:To>\n        <h:BizMsgIdr>20230516021150706YsLqbMIpE34960640</h:BizMsgIdr>\n        <h:MsgDefIdr>pacs.002.001.10</h:MsgDefIdr>\n        <h:MktPrctc>\n            <h:Regy>www2.swift.com/mystandards/#/group/Federal_Reserve_Financial_Services/FedNow_Service</h:Regy>\n            <h:Id>frb.fednow.01</h:Id>\n        </h:MktPrctc>\n        <h:CreDt>2023-05-15T15:17:11-04:00</h:CreDt>\n        <h:BizPrcgDt>2023-05-15T00:00:00-04:00</h:BizPrcgDt>\n    </h:AppHdr>\n    <p:FIToFIPmtStsRpt>\n        <p:GrpHdr>\n            <p:MsgId>20230516021150706qNQmPNEOj27845234</p:MsgId>\n            <p:CreDtTm>2023-05-15T19:17:11</p:CreDtTm>\n        </p:GrpHdr>\n        <p:TxInfAndSts>\n            <p:OrgnlGrpInf>\n                <p:OrgnlMsgId>20230515021040078jGEuvmkFm25336925</p:OrgnlMsgId>\n                <p:OrgnlMsgNmId>pacs.008.001.08</p:OrgnlMsgNmId>\n                <p:OrgnlCreDtTm>2023-05-15T19:17:10</p:OrgnlCreDtTm>\n            </p:OrgnlGrpInf>\n            <p:OrgnlInstrId>eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq</p:OrgnlInstrId>\n            <p:OrgnlEndToEndId>nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f</p:OrgnlEndToEndId>\n            <p:OrgnlTxId>vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr</p:OrgnlTxId>\n            <p:OrgnlUETR>462c23a1-bff1-48e2-922b-86b96f88e89d</p:OrgnlUETR>\n            <p:TxSts>RJCT</p:TxSts>\n            <p:StsRsnInf>\n                <p:Rsn>\n                    <p:Cd>NARR</p:Cd>\n                </p:Rsn>\n                <p:AddtlInf>Providing additional info</p:AddtlInf>\n            </p:StsRsnInf>\n            <p:InstgAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021150706</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstgAgt>\n            <p:InstdAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040078</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstdAgt>\n        </p:TxInfAndSts>\n    </p:FIToFIPmtStsRpt>\n</p:Document>\n",
            "timeStamp": "2023-05-15T19:17:11.389+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": null,
            "creditorAccID": null,
            "status": null
        },
        {
            "messageId": "20230516021150706FYjIVYyyE38459281",
            "messageStatus": "IB_RES_FNS_TO_PGW",
            "messageType": "pacs.002.001.10",
            "messageStatusDescription": "Inbound response from Fednow Simulator to Payment Gateway",
            "message": "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<p:Document xmlns:p=\"urn:iso:std:iso:20022:tech:xsd:pacs.002.001.10\" xmlns:h=\"urn:iso:std:iso:20022:tech:xsd:head.001.001.02\">\n    <h:AppHdr>\n        <h:Fr>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021150706</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:Fr>\n        <h:To>\n            <h:FIId>\n                <h:FinInstnId>\n                    <h:ClrSysMmbId>\n                        <h:MmbId>021040079</h:MmbId>\n                    </h:ClrSysMmbId>\n                </h:FinInstnId>\n            </h:FIId>\n        </h:To>\n        <h:BizMsgIdr>20230516021150706YgVkCuvGc88565924</h:BizMsgIdr>\n        <h:MsgDefIdr>pacs.002.001.10</h:MsgDefIdr>\n        <h:MktPrctc>\n            <h:Regy>www2.swift.com/mystandards/#/group/Federal_Reserve_Financial_Services/FedNow_Service</h:Regy>\n            <h:Id>frb.fednow.01</h:Id>\n        </h:MktPrctc>\n        <h:CreDt>2023-05-15T15:17:11-04:00</h:CreDt>\n        <h:BizPrcgDt>2023-05-15T00:00:00-04:00</h:BizPrcgDt>\n    </h:AppHdr>\n    <p:FIToFIPmtStsRpt>\n        <p:GrpHdr>\n            <p:MsgId>20230516021150706FYjIVYyyE38459281</p:MsgId>\n            <p:CreDtTm>2023-05-15T19:17:11</p:CreDtTm>\n        </p:GrpHdr>\n        <p:TxInfAndSts>\n            <p:OrgnlGrpInf>\n                <p:OrgnlMsgId>20230515021040078jGEuvmkFm25336925</p:OrgnlMsgId>\n                <p:OrgnlMsgNmId>pacs.008.001.08</p:OrgnlMsgNmId>\n                <p:OrgnlCreDtTm>2023-05-15T19:17:10</p:OrgnlCreDtTm>\n            </p:OrgnlGrpInf>\n            <p:OrgnlInstrId>eDfL662-Mmie-42Ou-9JSf-UhHQYtxQgpZq</p:OrgnlInstrId>\n            <p:OrgnlEndToEndId>nfeu8mL-Qt9T-4dNq-9z1z-R6OeemugUX1f</p:OrgnlEndToEndId>\n            <p:OrgnlTxId>vrxxlza-FBCg-4idf-bJag-js2TkLEWObrr</p:OrgnlTxId>\n            <p:OrgnlUETR>462c23a1-bff1-48e2-922b-86b96f88e89d</p:OrgnlUETR>\n            <p:TxSts>RJCT</p:TxSts>\n            <p:StsRsnInf>\n                <p:Rsn>\n                    <p:Cd>NARR</p:Cd>\n                </p:Rsn>\n                <p:AddtlInf>Providing additional info</p:AddtlInf>\n            </p:StsRsnInf>\n            <p:InstgAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021150706</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstgAgt>\n            <p:InstdAgt>\n                <p:FinInstnId>\n                    <p:ClrSysMmbId>\n                        <p:ClrSysId>\n                            <p:Cd>USABA</p:Cd>\n                        </p:ClrSysId>\n                        <p:MmbId>021040079</p:MmbId>\n                    </p:ClrSysMmbId>\n                </p:FinInstnId>\n            </p:InstdAgt>\n        </p:TxInfAndSts>\n    </p:FIToFIPmtStsRpt>\n</p:Document>\n",
            "timeStamp": "2023-05-15T19:17:11.430+00:00",
            "messageDefId": null,
            "statusMessage": null,
            "reasonCode": null,
            "creditorAgentRTN": null,
            "creditorAccID": null,
            "status": null
        }
    ]
}